(() => {
  // Konfiguration
  // Das Raster ist an die INHALTSBREITE gekoppelt: COLUMNS Zellen spannen sich über
  // die Inhaltsspalte (.page-width). Dadurch skaliert der Rasterabstand 1:1 mit dem
  // Inhalt mit – beim Zoomen (Strg +/-) oder bei anderer Fensterbreite bleiben Raster
  // und Boxen ausgerichtet. Bei der Design-Breite (page_width 1200px) ergibt das die
  // ursprünglichen 120px pro Zelle.
  // Spaltenzahl pro Seite steuerbar über CSS: body.template-xxx { --grid-columns: 14 }.
  // Standard 10. So lässt sich die Rasterdichte je Seite festlegen.
  // Die Spaltenzahl wird bei JEDEM Zeichnen neu gelesen, nicht einmal beim Laden.
  // Grund: Sie haengt inzwischen an einer Media Query (Tablet-Band = 10 Spalten statt 14).
  // Als const beim Start eingefroren, behielt das gemalte Raster nach einer
  // Breitenaenderung die alte Spaltenzahl, waehrend das Layout schon die neue benutzte —
  // Raster und Inhalt liefen genau dann auseinander, wenn man die Fenstergroesse aendert.
  const readColumns = () => {
    const v = parseInt(getComputedStyle(document.body).getPropertyValue('--grid-columns'), 10);
    return (Number.isFinite(v) && v > 0) ? v : 10;
  };
  let COLUMNS = readColumns();

  // === Spaltenzahl ABLEITEN statt pro Aufloesung festlegen ===
  // Bisher war die Spaltenzahl der EINGABEWERT (14 am Schreibtisch, 11 bzw. 10 auf
  // Tablets, jeweils von Hand in einer Media Query) und die Zellgroesse das Ergebnis:
  //     Zelle = Containerbreite / Spalten
  // Damit war die Zelle bei jeder Fensterbreite eine andere - 90px bei 1920, 100,5px
  // bei 1180, 83,2px bei 1133. Jedes Element, das in Zellen positioniert ist, landete
  // dadurch bei jeder Aufloesung an einer anderen Stelle relativ zu den Rasterlinien
  // und musste einzeln nachjustiert werden. Das ist die Ursache dafuer, dass jede neue
  // Bildschirmgroesse Handarbeit verlangte.
  //
  // Jetzt umgekehrt: Die ZELLE ist die Konstante (das Designmass), die Spaltenzahl
  // ergibt sich aus dem vorhandenen Platz:
  //     Spalten = round(Containerbreite / Designzelle)
  // Die Zelle bleibt dadurch immer dicht am Designmass (bei n Spalten zwischen
  // n/(n+0,5) und n/(n-0,5) davon, also z.B. 86,4 - 93,9px bei 12 Spalten), und wie
  // viele Kacheln in eine Zeile passen, faellt von selbst heraus: Kachel = 3 Zellen,
  // Sidebar = 2 Zellen stehen fest, der Rest ist Arithmetik. Derselbe Gedanke wie
  // repeat(auto-fill, ...) im CSS-Grid, nur auf das gemalte Raster angewendet.
  //
  // Das Designmass muss dafuer NICHT neu gepflegt werden - es steht schon im CSS.
  // body.template-collection und Geschwister deklarieren
  //     --cell: calc(var(--shop-width) / var(--grid-columns))
  // also 1260/14 = 90px im Shop, 1180/10 = 118px auf der Startseite. Genau dieser
  // deklarierte Wert wird hier gelesen; es gibt keine zweite Zahl, die auseinander-
  // laufen koennte.
  //
  // Gelesen wird er OHNE den Inline-Wert, den render() weiter unten selbst auf den
  // <body> schreibt - sonst laese man die eigene Messung des letzten Bildes zurueck
  // und die Spaltenzahl wanderte von Bild zu Bild.
  //
  // Gemessen wird ueber ein PROBE-Element, nicht ueber getComputedStyle. Das ist kein
  // Umweg, sondern noetig: Custom Properties haben keinen ausgerechneten Wert. Ein
  //     getComputedStyle(body).getPropertyValue('--cell')
  // liefert die Zeichenkette "calc(126rem / 14)" - den unveraenderten Text aus dem
  // Stylesheet. parseFloat davon ist NaN, und die Ableitung fiel dadurch stumm auf den
  // alten Weg zurueck, ohne dass irgendwo ein Fehler auftauchte.
  // Ein Element mit width: var(--cell) dagegen zwingt den Browser, den Ausdruck fuer
  // die Layoutberechnung wirklich auszurechnen - offsetWidth ist dann eine echte Zahl.
  // Das funktioniert auf jeder Seite gleich, ohne die Anker-Variablen einzeln zu kennen.
  let designCell = null;
  const readDesignCell = () => {
    if (designCell !== null) return designCell;
    // Die eigenen Inline-Werte kurz beiseitelegen, sonst misst man die letzte eigene
    // Messung statt der Design-Vorgabe.
    //
    // BEIDE, <html> UND <body>. Hier stand lange nur der body - und das ging so lange
    // gut, wie die Seite ueberhaupt ein --cell deklariert (Shop, Blog, Suche, Startseite:
    // dort schlaegt die Deklaration am body den Inline-Wert am html, und die Messung
    // stimmte). Die PRODUKTSEITE deklariert keines. Dort erbte das Probe-Element den
    // Inline-Wert vom <html> - also genau die Zahl, die dieses Skript im letzten Bild
    // selbst geschrieben hatte.
    //
    // Damit war die Rechnung rueckgekoppelt und lief weg: gemessene Zelle -> Spaltenzahl
    // -> groessere Zelle -> weniger Spalten -> noch groessere Zelle. Sichtbar als Seite,
    // die einen Moment richtig aussieht und dann hineinzoomt; gemessen 171,4px Zelle und
    // 7 Spalten statt der 10, mit denen die Produktseite entworfen ist.
    //
    // Ohne deklariertes Mass liefert die Messung jetzt 0, und resolveColumns faellt
    // sauber auf readColumns() zurueck - das ist der Zustand, fuer den die Seite
    // gestaltet wurde.
    const eigen = document.body.style.getPropertyValue('--cell');
    const eigenHtml = document.documentElement.style.getPropertyValue('--cell');
    if (eigen) document.body.style.removeProperty('--cell');
    if (eigenHtml) document.documentElement.style.removeProperty('--cell');
    const probe = document.createElement('div');
    // display:block ist PFLICHT, nicht Kosmetik. Das Theme blendet nackte <div> im Body
    // aus (der Body ist ein Flex-Container mit festgelegten Kindern). Ohne die Angabe
    // stand das Probe-Element auf display:none: getComputedStyle lieferte zwar korrekt
    // 90px, aber getBoundingClientRect().width war 0 - ein ausgeblendetes Element hat
    // keine Box. designCell wurde dadurch 0, und die ganze Ableitung fiel stumm auf den
    // alten Weg zurueck. visibility:hidden statt Ausblenden: unsichtbar, aber gemessen.
    probe.style.cssText =
      'position:absolute!important;display:block!important;visibility:hidden;' +
      'left:-9999px;top:0;height:0;padding:0;border:0;width:var(--cell)';
    document.body.appendChild(probe);
    const v = probe.getBoundingClientRect().width;
    probe.remove();
    if (eigen) document.body.style.setProperty('--cell', eigen);
    if (eigenHtml) document.documentElement.style.setProperty('--cell', eigenHtml);
    designCell = (Number.isFinite(v) && v > 0) ? v : 0;
    return designCell;
  };

  // === Die Spaltenzahl so waehlen, dass die Kacheln AUFGEHEN ===
  // round(Breite / Designzelle) allein genuegt nicht. Das Kachelfeld ist in Vierergruppen
  // aufgebaut - jede Kachel belegt 3 Zellen und danach folgt 1 Zelle Luecke:
  //     mit Seitenmenue:   2 + 1 + [3+1] + [3+1] + 3  = 14 Zellen fuer 3 Kacheln
  //     ohne Seitenmenue:      [3+1] + [3+1] + 3      = 11 Zellen fuer 3 Kacheln
  // Passt die Spaltenzahl nicht in dieses Schema, bleibt rechts ein Rest stehen, den
  // keine Kachel mehr fuellt. Genau das war bei 1180px quer zu sehen: 14 Spalten, aber
  // nur 11 davon benutzt - rund 240px tote Flaeche am rechten Rand.
  //
  // Moegliche Spaltenzahlen sind damit nur:
  //     mit Seitenmenue:  6, 10, 14, 18, ...   (3 + 4k - 1)
  //     ohne:             3,  7, 11, 15, ...   (4k - 1)
  // Gewaehlt wird davon die, deren Zelle dem Designmass am naechsten kommt:
  //     Zelle(k) = Containerbreite / (belegt + 4k - 1)   ->  |Zelle(k) - Designzelle| minimal
  //
  // Diese Formulierung ist bewusst und ersetzt ein einfaches Runden der Rohzahl. Runden
  // entscheidet nach der SPALTENZAHL, worauf es ankommt ist aber die ZELLGROESSE - und
  // beide haengen nichtlinear zusammen, weil eine Kachel gleich vier Spalten kostet.
  // Bei 1210px quer lagen 3 und 4 Kacheln fast gleichauf; das Runden ging nach oben und
  // waehlte 15 Spalten mit einer Zelle von 75,9px, waehrend direkt daneben bei 1180px
  // 11 Spalten mit 100,9px standen. Ein Sprung von 25 % in der Zellgroesse - und weil
  // alle senkrechten Abstaende in Zellen gerechnet sind, rutschten Titel und
  // Filterleiste sichtbar nach oben. Nach Zellgroesse entschieden bleiben es 11 Spalten
  // (103,5px), und der Uebergang von 1180 nach 1210 verlaeuft glatt.
  //
  // Ein Sprung an IRGENDEINER Breite bleibt unvermeidbar: Eine Kachel ist 3 Zellen breit
  // plus 1 Zelle Luecke, die Kachelzahl kann also nur ganzzahlig springen. Diese Regel
  // legt den Sprung genau dorthin, wo beide Varianten gleich weit vom Designmass weg
  // sind - weiter laesst er sich nicht entschaerfen.
  //
  // Nur auf Seiten mit Kachelraster. Startseite, Beitraege und Rechtstexte haben kein
  // Vierer-Schema, dort bleibt die gerundete Rohzahl stehen.
  // Obergrenze der Kachelzahl: so viele, wie der ENTWURF vorsieht - nicht mehr.
  // Abgeleitet aus der deklarierten Spaltenzahl (--grid-columns, im Shop 14):
  //     Kacheln = floor((deklarierte Spalten - belegt + 1) / 4)
  // Mit Seitenmenue (belegt 3): (14 - 3 + 1)/4 = 3. Ohne: (14 + 1)/4 = 3,75 -> 3.
  // Beide Male drei - genau das Referenzbild bei 1920px.
  //
  // Wozu die Grenze: Zwischen 1278 und 1279px lagen 3 und 4 Kacheln so dicht beieinander,
  // dass kurz vier erschienen - auf zwei Pixel Fensterbreite, direkt bevor bei 1280px das
  // Seitenmenue einsetzt und wieder drei daraus werden. Eine Kachelzahl, die mit
  // wachsendem Fenster erst steigt und sofort wieder faellt, ist immer falsch.
  // Statt dafuer eine weitere Zahl zu erfinden, gilt die Vorgabe aus dem Entwurf.
  const maxKacheln = (belegt) =>
    Math.max(1, Math.floor((readColumns() - belegt + 1) / 4));
  // Eine zu KLEINE Zelle wiegt doppelt so schwer wie eine zu grosse.
  //
  // Das ist kein Feinschliff, sondern der Unterschied zwischen den beiden Richtungen:
  // Faellt die Zelle unter das Designmass, schrumpfen Produktbilder, Titel und Preise
  // mit - die Kachel wird schlechter lesbar. Liegt sie darueber, wird die Seite nur
  // luftiger, es geht nichts verloren. Gleich zu gewichten hiesse, beides fuer gleich
  // schlimm zu halten.
  //
  // Ohne diese Gewichtung sprang das Layout an zwei Stellen auf eine Kachel mehr und
  // quetschte die Zelle dabei zusammen: bei 830px auf 70,2px (-22 %) und bei 1220px auf
  // 76,6px (-15 %). Beide Male lagen die Varianten fast gleichauf, und die knappe
  // Mehrheit fiel auf die schlechtere Seite. Mit dem Faktor 2 bleiben es dort 2 bzw. 3
  // Kacheln mit einer Zelle ueber dem Designmass, und die Kachelzahl waechst ueber den
  // ganzen Bereich monoton mit der Fensterbreite, statt zwischendurch zurueckzuspringen.
  //
  // Der Faktor ist eine Entwurfsentscheidung, kein gemessener Wert - aber es ist EINE
  // Zahl fuer alle Bildschirmgroessen, keine Zahl je Aufloesung.
  const STRAFE_ZU_KLEIN = 2;
  const snapToLayout = (breite, dz) => {
    const roh = Math.round(breite / dz);
    const grid = document.querySelector('.product-grid');
    if (!grid || !grid.offsetParent) return roh;
    const side = document.querySelector('.collection-sidebar');
    const sichtbar = side && side.offsetParent && side.getBoundingClientRect().width > 0;
    const belegt = sichtbar ? 3 : 0;          // Seitenmenue 2 Zellen + 1 Zelle Luecke
    let beste = belegt + 3, kleinsteKosten = Infinity;
    const grenze = maxKacheln(belegt);
    for (let k = 1; k <= grenze; k++) {
      const n = belegt + 4 * k - 1;
      const differenz = breite / n - dz;
      const kosten = differenz >= 0 ? differenz : -differenz * STRAFE_ZU_KLEIN;
      if (kosten < kleinsteKosten) { kleinsteKosten = kosten; beste = n; }
    }
    return beste;
  };
  // Untergrenze: Unter 4 Spalten passt keine Kachel (3 Zellen) mehr neben einen Rand.
  // Greift praktisch nie, weil das Raster unter 750px ohnehin ruht.
  const MIN_COLUMNS = 4;

  // === GLEICHE ZELLE AUF ALLEN SEITEN (13.09.2026) ===
  // Vorher leitete jede Seite ihre Zelle aus ihrem eigenen Container ab: 90px im Shop,
  // 118px auf der Startseite, 120px auf der Produktseite, 72,6px auf Beitragsseiten
  // (bei 1920). Jetzt gilt fuer JEDE Seite die Zelle des Shops - sie haengt nur noch von
  // der Fensterbreite ab, nicht vom Inhalt der Seite.
  //
  // Die Rechnung ist genau die des Shop-Containers (base.css, .collection-with-sidebar):
  //   Breite  = min(126rem, (100vw - 3rem) * 0,965), im Tablet-Querband zusaetzlich
  //             hoechstens 11 Designzellen (990px)
  //   Spalten = gleiche Auswahl wie snapToLayout: belegt + 4k - 1, mit Seitenmenue
  //             (ab 1280px) belegt = 3, Kachelzahl hoechstens 3
  //   Zelle   = Breite / Spalten
  // Gemessen stimmt das mit dem Shop ueberein: 90 bei 1920/1440, 86,2 bei 1280, 90 bei
  // 1133 und 1180, 87,2 bei 1024, 113,3 bei 852 quer.
  //
  // Nur wo das Raster sichtbar ist. Handy und Tablet hochkant rechnen weiter wie bisher,
  // damit die Referenz 393x852 unberuehrt bleibt.
  const DESIGN_ZELLE_REM = 9;        // = --shop-width 126rem / 14 Spalten
  const DESIGN_SPALTEN = 14;
  const globaleZelle = () => {
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
    const dz = DESIGN_ZELLE_REM * rem;
    const vw = window.innerWidth;
    const querband = vw >= 750 && vw < 1280 && window.matchMedia('(orientation: landscape)').matches;
    let breite = Math.min(DESIGN_SPALTEN * dz, (vw - 3 * rem) * 0.965);
    if (querband) breite = Math.min(breite, 11 * dz);
    const belegt = vw >= 1280 ? 3 : 0;
    const grenze = Math.max(1, Math.floor((DESIGN_SPALTEN - belegt + 1) / 4));
    // REGEL KACHELSEITEN 2 (14.09.2026): Jede Kachelzeile hat 3 Kacheln - auf JEDER Groesse
    // mit Raster. Die Spaltenzahl ist damit fest (mit Seitenmenue 14, sonst 11); die Zelle
    // folgt allein aus der Breite. Folge: Im Querband 750-891px, wo vorher 2 Kacheln standen,
    // ist die Zelle auf allen Seiten kleiner (852x393: rund 72 statt 113px).
    // STILLGELEGT - vorher wurde die Kachelzahl nach dem Designmass gewaehlt:
    //   let beste = belegt + 3, kleinsteKosten = Infinity;
    //   for (let k = 1; k <= grenze; k++) {
    //     const n = belegt + 4 * k - 1;
    //     const differenz = breite / n - dz;
    //     const kosten = differenz >= 0 ? differenz : -differenz * STRAFE_ZU_KLEIN;
    //     if (kosten < kleinsteKosten) { kleinsteKosten = kosten; beste = n; }
    //   }
    const beste = belegt + 4 * grenze - 1;
    // REGEL KACHELSEITEN 1 - auch der AEUSSERSTE Rahmen muss im Fenster liegen. Die Kacheln
    // stehen in Rahmen von 4 Zellen, die je eine halbe Zelle ueber den Kachelbereich
    // hinausragen: ohne Seitenmenue 12 Zellen mittig, mit Seitenmenue reicht der rechte Rahmen
    // 7,5 Zellen ueber die Mitte. Beides ist (Spalten + 1) Zellen, bezogen auf die Mitte.
    // Die Zelle wird deshalb so begrenzt, dass (Spalten + 1) Zellen plus ein kleiner Rand in
    // die Fensterbreite passen. Vorher lag die rechte Rahmenlinie bei 1280 6px und bei 1024
    // beide aeusseren je 11px ausserhalb des Fensters.
    // STILLGELEGT - vorher ohne Deckel: return { spalten: beste, zelle: breite / beste };
    const RAHMEN_RAND = 0.5 * rem;
    const fenster = document.documentElement.clientWidth || vw;
    const zelle = Math.min(breite / beste, (fenster - 2 * RAHMEN_RAND) / (beste + 1));
    return { spalten: beste, zelle };
  };
  const resolveColumns = (breite) => {
    const dz = readDesignCell();
    if (!dz) return readColumns();   // kein deklariertes Mass -> Verhalten wie bisher
    return Math.max(MIN_COLUMNS, snapToLayout(breite, dz));
  };
  const SPACING_FALLBACK = 120; // px, solange die Inhaltsspalte noch nicht messbar ist
  // Farben aus den zentralen CSS-Tokens lesen (Fallback = bisherige Werte),
  // damit der Raster-Look automatisch der Marken-Farbe folgt.
  const _root = getComputedStyle(document.documentElement);
  const _brandRed = _root.getPropertyValue('--brand-red').trim() || '#99220A';
  const _brandRedRgb = _root.getPropertyValue('--brand-red-rgb').trim() || '153, 34, 10';
  const DOT_COLOR = _brandRed;
  const LINE_COLOR = `rgba(${_brandRedRgb}, 0.25)`;
  const LINE_WIDTH = 1;

  // Werden pro Render aus der Inhaltsbreite berechnet (siehe unten), damit alles
  // proportional mitskaliert. Startwerte = bisheriges Aussehen bei Design-Breite.
  let SPACING = SPACING_FALLBACK;
  let DOT_RADIUS = 4;
  let PADDING = 8;
  // Horizontaler Versatz relativ zur Inhaltsspalte: eine halbe Zelle nach links,
  // damit der Inhalt mittig zwischen den Linien sitzt.
  let GRID_SHIFT_X = -SPACING / 2;

  // WEICHER Schnitt: Segmente werden am nächstgelegenen Punkt unterbrochen
  const BLOCKING_SELECTORS = [
    '.rich-text__blocks',
    // Textbox: WEICHER Schnitt – das Raster endet am nächstgelegenen Rasterpunkt rund um
    // die Box (grid-bündig), NICHT als hartes Box-Rechteck. Der deckende Hintergrund bleibt
    // für die Lesbarkeit; seine Kante liegt innerhalb der ausgesparten Zone und ist unsichtbar.
    // Die einzelnen Textzeilen ('main h1..h3, p') sperren bewusst NICHT (sonst ausgefranst).
    '.image-with-text__content',
    '.image-with-text__media',
    // Das Foto SELBST zusaetzlich: Auf der Startseite ist es per Zoom und Neigung groesser
    // als sein Kasten (gemessen 11px seitlich, 27px unten ueber .image-with-text__media).
    // Gesperrt war nur der Kasten - seit das Raster die Shop-Zelle hat (dichter), lag eine
    // Linie genau in diesem Streifen unter dem Foto. getBoundingClientRect enthaelt die
    // Transformation, das Rechteck deckt also das sichtbare Foto.
    // STILLGELEGT (14.09.2026): '.image-with-text__media img',
    // Das Foto wird von seinem Medienrahmen (overflow: hidden) beschnitten - sichtbar ist
    // genau das gedrehte Rechteck von .image-with-text__media, und das sperrt bereits (mit
    // Neigung, getBoundingClientRect). Das <img> selbst ist per scale(1.09) groesser; sein
    // Rechteck ragte 11px seitlich und 28px unten ueber das sichtbare Foto und nahm genau
    // die Rahmenlinien weg, an denen das erste Bild jetzt ausgerichtet wird (links an der
    // Kachel-Linie, unten an der Mittellinie).
    // Inhalts-Platte "Über uns": weicher Schnitt statt hartem Rechteck. Die Box ist deckend
    // (--brand-beige) und verdeckte das Raster bisher exakt an ihrer Kante — mitten in Linien
    // und Punkten. Als Sperrfläche endet das Raster jetzt am nächstgelegenen Rasterpunkt rund
    // um die Box; ihre eigene Kante liegt innerhalb der ausgesparten Zone und ist unsichtbar.
    '.ueber-uns-page',
    '.category-tiles__grid',
    // Das Sternbild auf den Kategoriekacheln ragt teils ueber die Kachelflaeche hinaus:
    // Beim Rezepte-Zettel ist es bewusst nach links versetzt (left: 42 %, siehe
    // section-category-tiles.css). Bei 1024px begann es 25px vor der gesperrten Flaeche,
    // und dort lief eine senkrechte Linie unter ihm durch.
    '.category-tile__constellation',
    '.collection-sidebar',
    // --- Blogseiten („Neues“/„Rezepte“) ---
    // Dieselben Rollen wie im Shop, damit das Raster dort genauso bricht:
    // Seitenmenü, Kachel, Überschrift, „Mehr laden“.
    // Bewusst NICHT die ganze Kachel (.blog-card): Bild und Titel sperren einzeln,
    // dadurch läuft das Raster in der Lücke zwischen beiden weiter durch, statt dass
    // die Kachel als ein Block ein ganzes Feld ausspart.
    '.blog-sidebar',
    '.blog-card__media',
    '.blog-card__title',
    '.blog-heading',
    // Hinweistext einer noch leeren Kategorie (sections/main-404.liquid)
    '.blog-empty',
    '.blog-load-more',
    // Produktkarten: NUR die Box (Kachel-Footprint) bricht das Raster – als sauberes Rechteck.
    // Bild/Text/Logo/Buttons liegen frei darauf und beeinflussen das Raster NICHT.
    '.product-card-wrapper',
    '.banner',
    // Collection-Überschrift ("Alle Produkte") vom Raster einzäunen (weicher Schnitt
    // rund um den Titel, grid-bündig).
    '.collection-page-title',
    // Ueberschrift der Suchergebnisse: ebenfalls weicher Schnitt. Sie ist als
    // Flex-Element nur so breit wie ihr Text — eine Box ueber die volle Spaltenbreite
    // wuerde eine waagerechte Rasterlinie quer ueber die Seite loeschen statt nur rund
    // um den Titel (gleiche Ueberlegung wie bei .blog-heading).
    '.search-page-title',
    // Statuszeile der Suche ("Keine Ergebnisse gefunden fuer …" bzw. die Trefferzahl):
    // ebenfalls weicher Schnitt, sonst laufen die Linien mitten durch den Satz.
    // Die Zeile ist per width: fit-content nur so breit wie ihr Text (template-search.css)
    // — ueber die volle Spaltenbreite wuerde sie eine waagerechte Linie quer ueber die
    // Seite loeschen statt nur rund um den Text.
    '.template-search__status',
    // Suchfeld der Suchergebnisseite (<main-search> umschliesst das Formular): weicher
    // Schnitt, damit keine Rasterlinie durch das Eingabefeld laeuft. Bewusst das
    // Element und nicht '.field' — dessen Rechteck ist identisch, aber die Klasse
    // traegt jedes Eingabefeld des Themes, auch im Anmelde- und Kontaktformular.
    // Das Feld im Kopfbereich der Seite ist davon nicht betroffen: Der Header wird
    // ohnehin hart abgeschnitten (HARD_CLIP_SELECTORS).
    'main-search',
    // Der ganze Kopfblock der Suche (Ueberschrift + Suchfeld + Statuszeile) schneidet
    // ebenfalls weich. Seit der Block im Querband tiefer sitzt, liefen die Rasterlinien
    // sonst durch Ueberschrift und Eingabefeld. Ein Eintrag fuer den ganzen Block
    // schneidet rund um ihn am naechstgelegenen Rasterpunkt.
    '.template-search__header',
    // --- Füllinhalte leerer Seiten ---
    // Seiten ohne echten Inhalt (leerer Warenkorb, Kategorie ohne Treffer, 404) zeigen nur
    // ein paar zentrierte Zeilen. Ohne Eintrag liefen die Rasterlinien mitten durch diese
    // Schrift — auf einer sonst leeren Seite fällt das besonders auf.
    //
    // Beim Warenkorb und der 404-Seite sperrt der ganze Block: Überschrift, Schaltfläche
    // und Text stehen dicht gestapelt, einzeln gesperrt fransten die Aussparungen aus.
    '.cart__warnings',
    // Fehlerseite: bewusst .not-found-message (der Inhaltsblock) und NICHT .template-404.
    // Diese Klasse trägt auch der <body> — layout/theme.liquid setzt
    // template-{{ request.page_type }}. Als Sperrfläche war damit die GANZE Seite
    // gesperrt: jedes Liniensegment und jeder Punkt fiel weg, der Canvas blieb leer.
    // Das Raster fehlte dadurch auf jeder 404-Seite — ohne Fehlermeldung.
    '.not-found-message',
    // Beim leeren Produktraster dagegen bewusst NUR der Textblock und nicht
    // '.collection--empty': Dessen Rechteck ist knapp 1000 × 350 gross, obwohl darin nur
    // zwei Zeilen stehen. Gesperrt risse es ein grosses rasterfreies Loch in die Seite,
    // während der Text selbst nur einen Bruchteil davon einnimmt.
    // Gilt zugleich für die leere Suche (main-search.liquid nutzt dieselbe Klasse).
    '.collection--empty .title-wrapper',
    // "Mehr laden"-Button: Raster weich um ihn herum unterbrechen (nur der Button selbst,
    // nicht sein Wrapper – der ist 1 Zelle hoch und würde ein ganzes Band aussparen).
    '.collection-load-more',
    // Filter-/Sortierleiste: weicher Schnitt, damit ihr Hintergrund das Raster sauber
    // grid-bündig unterbricht (früher war sie bewusst ausgenommen).
    '.facets-container',
    // --- Produktdetailseite ---
    // Infobox und Bildquadrat stehen NICHT hier, sondern in INSET_BLOCKING_SELECTORS: Ihre
    // Kanten liegen auf Rasterlinien, und diese Linien sollen sichtbar bleiben. Das normale
    // Polster hier würde sie mit wegnehmen.
    //
    // Kaufbox als EIN Rechteck. Früher standen hier ihre beiden Hälften einzeln — seit sie
    // eine gemeinsame Hülle haben (.product__buy-box, sections/main-product.liquid), genügt
    // ein Eintrag, und es kann nicht mehr passieren, dass nur eine Hälfte sperrt.
    // Sie steht überhaupt erst in dieser Liste, seit die Box mittig in EIN Rasterfeld
    // eingepasst ist: Zwischen ihren Kanten und den Linien darüber/darunter liegen ~22px, mehr
    // als das Polster (PADDING ≈ 8px). Die waagerechten Linien des Felds bleiben deshalb
    // stehen, nur die Senkrechten IM Feld werden unterbrochen — das ist der gewollte weiche
    // Schnitt. Solange die Box noch auf den Linien saß, hätte der Eintrag sie mitsamt den
    // Nachbarsegmenten verschluckt.
    '.product__buy-box',
    // Bewusst die ÜBERSCHRIFT und nicht .product__title-top: der Zonen-Wrapper ist seit den
    // festen Zonenhöhen eine Box über die volle Inhaltsbreite. Endet seine Unterkante knapp
    // hinter einer waagerechten Rasterlinie, streift er JEDES Segment dieser Linie — und
    // löschte sie damit quer über die ganze Seite. Die h1 ist als Flex-Element nur so breit
    // wie der Text und sperrt genau dort, wo sonst eine Linie durch die Schrift liefe.
    '.product__title-top h1',
    // Tab-Inhalt der Produktseite: weicher Schnitt um den jeweils OFFENEN Panel-Inhalt.
    // Geschlossene Panels haben auf dem Desktop display: none und damit ein 0×0-Rechteck —
    // collectRects filtert sie heraus, es sperrt also immer nur der sichtbare Tab.
    '.product-tabs__content',
    // Dazu der ganze Tab-Block (Button-Leiste + Panels) als ein Rechteck, damit das Raster
    // auch nicht durch die Schaltflächenleiste läuft, sondern rund um den kompletten Block
    // am nächstgelegenen Rasterpunkt endet.
    // Bewusst .product-tabs-section (die page-width-Box) und NICHT die äußere Sektionshülle
    // .section-product-tabs: die läuft über die volle Fensterbreite, ihr Rechteck würde das
    // Raster in einem ganzen waagerechten Band bis zu den Fensterrändern löschen. Auf allen
    // übrigen Seiten bleibt das Raster in den Seitenrändern neben der Inhaltsspalte sichtbar
    // — diese Box hält sich an dieselbe Kante.
    '.product-tabs-section',
    // Überschrift der Empfehlungen ("Das könnte Ihnen auch gefallen"): weicher Schnitt, damit
    // keine Rasterlinie durch die Schrift läuft. Die Einrastung oben legt sie mittig ins
    // Rasterfeld; das hier ist die Absicherung für die Fälle, in denen sie durch eine
    // Zeilenumbruch- oder Zoomänderung doch einmal an eine Linie stößt.
    '.related-products__heading',
    // --- Dr.-Hauschka-Markenseite (/pages/dr-hauschka) ---
    // Alle Inhaltsbloecke der Seite schneiden das Raster WEICH: es endet am
    // naechstgelegenen Rasterpunkt rund um den Block, statt an dessen Kante mitten in
    // Linien und Punkten abgedeckt zu werden.
    //
    // Gelbe Hero-Platte. Sie ist auf 9 Rasterzellen eingepasst (siehe --drh-hero-cells
    // in base.css), ihre Kanten liegen also auf senkrechten Rasterlinien. Bewusst der
    // NORMALE weiche Schnitt und nicht der kantentreue aus INSET_BLOCKING_SELECTORS:
    // hier sollen auch die beiden Kantenlinien weichen, damit die Platte frei steht.
    // STILLGELEGT (14.09.2026): '.drh-hero__inner',
    // Die Hero-Flaeche geht jetzt ueber die volle Breite und schneidet HART wie der
    // Shop-Banner - siehe HARD_CLIP_SELECTORS.
    // Sektionsueberschriften und Unterzeilen einzeln: Beides sind Blockelemente ueber die
    // volle Inhaltsbreite, ihr Rechteck ist aber nur so hoch wie die Zeile selbst. Die
    // Aussparung bleibt dadurch ein schmales Band um die Schrift, statt den Abstand bis
    // zum naechsten Block mitzunehmen.
    '.drh-h2',
    '.drh-sub',
    // Inhaltsbloecke. Bewusst die inneren Raster/Platten (.drh-icons, .drh-cols,
    // .drh-kat-grid, .drh-feature) und nicht die .page-width-Sektionen darum: deren
    // Rechteck schloesse die Ueberschrift und den Abstand darunter mit ein und risse
    // ein deutlich groesseres Loch als der sichtbare Block.
    // Ausnahmen sind .drh-credo und .drh-beratung — dort IST die Sektion der Block
    // (zentrierter Text bzw. beige Platte), es gibt darin keine eigene innere Huelle.
    // .drh-feature deckt beide Anordnungen ab, .drh-feature--reverse traegt die Klasse
    // ebenfalls und braucht keinen eigenen Eintrag.
    '.drh-icons',
    '.drh-credo',
    '.drh-cols',
    '.drh-kat-grid',
    '.drh-feature',
    '.drh-beratung',
    // --- Beitragsseite („Neues“/„Rezepte“, template-article) ---
    // Jeder Block einzeln statt der Huelle .article-template: Die geht ueber die volle
    // Seitenhoehe, ihr Rechteck loeschte das Raster von der Ueberschrift bis zum
    // Zurueck-Link am Stueck — auch in den Absaetzen dazwischen, wo gar nichts steht.
    // .article-template__content traegt zugleich die Klasse rte; der Eintrag hier ist
    // der genauere und deckt sie ab.
    '.article-template__title',
    '.article-template__content',
    '.article-template__social-sharing',
    '.article-template__linked-products',
    '.used-products',
    // Bewusst der LINK und nicht .article-template__back: Die Huelle ist zentriert und
    // geht ueber die volle Inhaltsbreite - als Sperrflaeche naehme sie dem Raster ein
    // ganzes Band, obwohl darin nur ein kurzer Link steht.
    '.article-template__link',
    // --- Rechtstexte (Impressum, AGB, Datenschutz, Versandbedingungen, Widerrufsrecht) ---
    // Gesperrt wird die deckende beige PLATTE und die Ueberschrift darueber, NICHT die
    // Huelle .shopify-policy__container: Die laeuft ueber die volle Fensterbreite und
    // ueber die ganze Texthoehe; ihr Rechteck loeschte das Raster auch in den Baendern
    // ober- und unterhalb des Textes, wo gar nichts steht.
    // Die Platte ist derselbe Fall wie .ueber-uns-page weiter oben: deckend in
    // --brand-beige, also verdeckte sie das Raster bisher exakt an ihrer Kante, mitten
    // in Linien und Punkten. Jetzt endet es am naechstgelegenen Rasterpunkt, und ihre
    // eigene Kante liegt in der ausgesparten Zone.
    // .legal-page ist das Gegenstueck fuer die Rechtstexte, die als normale Seite
    // gepflegt sind (Widerrufsrecht) — gleiche Gestaltung, anderes Markup.
    '.shopify-policy__title',
    '.shopify-policy__container .rte',
    '.legal-page',
    // --- Einfache Seiten, u.a. Kontakt ---
    // Ueberschrift und Fliesstext des Standardzweigs von sections/main-page.liquid.
    // Das .rte ist auf template-page eingegrenzt: Ohne diese Einschraenkung sperrte die
    // Klasse auch Produktbeschreibungen und Beitragstexte, die ihre eigenen, passenderen
    // Eintraege haben.
    //
    // Zusaetzlich auf main eingegrenzt — und das ist kein Schoenheitsfehler, sondern die
    // Behebung eines sichtbaren Lochs im Raster:
    //
    // Der Versandhinweis in der Fusszeile ist <div class="footer-shipping-note rte">, also
    // ebenfalls ein .rte im selben Dokument. Ohne "main" war er eine Sperrflaeche, obwohl
    // er nie so gemeint war. Auf Shop, Rezepten oder Beitraegen fiel das nicht auf, weil
    // der Body dort anders heisst und der Selektor gar nicht greift — auf jeder Seite vom
    // Typ "page" (Ueber uns, Kontakt) dagegen schon.
    //
    // Das Loch erschien OBERHALB der Fusszeile, obwohl der Hinweis darin liegt. Grund ist
    // die stueckweise Zeichnung der senkrechten Linien weiter unten: Jedes Stueck reicht
    // von einem Rasterpunkt bis zum naechsten, das letzte also von der untersten
    // Rasterzeile bis INS Innere der Fusszeile. Dort ueberlappte es die Sperrflaeche des
    // Hinweises, und damit fiel das GANZE Segment weg — nicht nur der Teil, den die harte
    // Schnittkante der Fusszeile ohnehin abschneidet. Uebrig blieb die Luecke zwischen
    // letzter Rasterzeile und Fusszeilenkante, genau so breit wie der Hinweistext.
    //
    // Der eigentliche Seiteninhalt bleibt gesperrt; "Ueber uns" hat mit .ueber-uns-page
    // ausserdem einen eigenen Eintrag.
    '.main-page-title',
    // Favoritenseite (17.09.2026): die Produktzahl neben der Ueberschrift. Nur sie, nicht
    // der Kopfbereich - der ist so breit wie die Spalte und loeschte eine Linie quer ueber
    // die Seite.
    '.favoriten-page__zahl',
    '.template-page main .rte',
    // Kontaktformular (sections/contact-form.liquid) als ein Block.
    '.contact',
    // Beratungsseite (sections/main-beratung.liquid): Platte samt Rückrufformular als ein
    // Block, wie .ueber-uns-page.
    '.beratung-seite',
    // --- Warenkorb ---
    // .cart__warnings weiter oben deckt den LEEREN Warenkorb ab; hier die gefuellte
    // Ansicht: Ueberschrift, Positionsliste und der Fuss mit Summe und Kasse.
    // Die Ueberschrift ueber template-cart eingegrenzt, weil .title-wrapper-with-link
    // auch in Sektionen der Startseite vorkommt.
    '.template-cart .title-wrapper-with-link',
    '.cart__items',
    // Warenkorb-Fussbereich als EIN Rechteck. .cart-zone umfasst Reisbalken,
    // Lieferbarkeitsfrage und Summenblock samt der Abstaende dazwischen; einzeln gesperrt
    // blieben in genau diesen Zwischenraeumen Rasterlinien stehen, je nach Artikelzahl
    // mal sichtbar, mal nicht. Bewusst .cart-zone und NICHT die .page-width darum: die
    // traegt 5rem seitliches Polster und wuerde rechts eine Rasterspalte zu viel nehmen.
    '.cart-zone',
    '.cart__footer'
  ].join(',');

  // NUR SENKRECHT sperrend: unterbricht die senkrechten Segmente (und Punkte) in seinem
  // Rechteck, lässt die waagerechten Linien aber durchlaufen.
  // Für den Produkttitel: sein Band soll eine luftige, leere Zeile sein, in der keine
  // Senkrechten durch den Namen laufen — die waagerechten Linien darüber und darunter bilden
  // aber gerade den Rahmen dieser Zeile und müssen bleiben. Sperrte der Titel wie üblich in
  // beide Richtungen, verschwände seine eigene Begrenzung quer über die ganze Seite.
  //
  // Diese Rechtecke werden EINGEZOGEN gemessen (siehe collectRects weiter unten), nicht
  // aufgeweitet. Grund: Die Titelzone geht über die volle Inhaltsbreite. Liegt ihre Unterkante
  // im Polsterabstand einer Rasterlinie, streift sie JEDES senkrechte Segment der Zeile
  // DARUNTER — und löschte damit quer über die Seite Linien, die mit dem Titel nichts zu tun
  // haben. Eingezogen endet ihre Wirkung an der eigenen Kante.
  const V_BLOCKING_SELECTORS = [
    '.product__title-top'
  ].join(',');

  // KANTENTREUER Schnitt: Das Rechteck wird EINGEZOGEN statt aufgeweitet.
  // Der normale weiche Schnitt legt um jede Sperrfläche noch ein Polster (PADDING) und wirft
  // jedes Segment weg, das dieses Polster berührt. Eine Linie, die GENAU auf der Kante liegt,
  // verschwindet dadurch immer — auch wenn sie dort gerade den Rahmen des Elements bilden
  // würde. Genau das ist bei Bild und Infobox erwünscht: ihre Kanten liegen auf Rasterlinien
  // und sollen diese Linien sichtbar lassen. Entfernt wird nur, was INNERHALB liegt.
  //
  // Damit das aufgeht, müssen die Kanten auch wirklich auf Linien liegen — siehe base.css:
  // --pdp-info-y / --pdp-info-cells (Infobox) und --pdp-img-y / --pdp-img-inset (Bild) sind
  // deshalb auf ganze Zellen gesetzt.
  const INSET_BLOCKING_SELECTORS = [
    '.product__info-container',
    '.product__media-item'
  ].join(',');

  // HARTER Schnitt: Raster wird exakt an der Elementkante abgeschnitten (auch mitten in der Linie)
  const HARD_CLIP_SELECTORS = [
    'footer.footer',
    // Oberes Menüband/Header: Raster wird an der Unterkante des (fixierten) Headers
    // sauber abgeschnitten, statt nur weich um ihn herumzubrechen.
    'header.header-wrapper',
    '.section-header',
    // Collection-Banner ("Was wir verkaufen können…"): Raster wird an der Banner-Kante
    // hart abgeschnitten (statt weich herumzubrechen).
    '.collection-hero',
    // REGELN 1-4 (13.09.2026), Regel 2: Genau diese fuenf Elemente schneiden hart -
    // Kopfzeile, Fusszeile, Shop-Banner und die beiden Textbanner der Blog- und der
    // Ueber-uns-Seite. Die Textbanner standen bisher in keiner Liste; das Raster lief
    // unter ihnen durch und war nur von ihrem deckenden Hintergrund verdeckt.
    '.blog-banner',
    '.ueber-uns-banner',
    // Dr. Hauschka (14.09.2026): Hero-Flaeche wie der Shop-Banner - volle Breite, Schatten,
    // harter Schnitt (section-main-page.css, DR. HAUSCHKA: HERO WIE DER SHOP-BANNER).
    '.drh-hero__inner'
  ].join(',');

  // Die harten Banner INNERHALB des Seiteninhalts (ohne Kopf- und Fusszeile). Gebraucht
  // fuer Regel 3 (Abstand zum Rasterbeginn) und Regel 4 (Seitenueberschrift darunter).
  const HARTE_BANNER = '.collection-hero, .blog-banner, .ueber-uns-banner, .drh-hero__inner';

  // === Regel 4: Seitenueberschriften ===
  // Je Gruppe die Elemente, die zusammen EINEN Kopfblock bilden (Ueberschrift samt
  // Filterleiste). Die erste Gruppe, deren erstes Element sichtbar ist, gewinnt.
  const KOPF_ANKER = [
    // Shop (14.09.2026): Ueberschrift und Filterleiste EINZELN mittig in ihrem Feld. Die Leiste
    // ist deshalb Folgeblock (FOLGE_ANKER): Im Querband steht sie UNTER dem Titel und bekommt
    // ihr eigenes Feld; ab 1280 liegt der Titel im Balken, beide Mitten fallen zusammen.
    // Seit die Leiste einzeilig ist (21 statt 36px hoch), passte das Paar bei 1024 in EIN Feld
    // - mittig war nur das Paar, nicht jedes Teil (Titel 0,38, Leiste 0,70).
    // STILLGELEGT - vorher als ein Block:
    //   ['.collection-with-sidebar__main > .collection-page-title', '.collection-with-sidebar__main .facets-container'],
    ['.collection-with-sidebar__main > .collection-page-title'],
    ['.search-page-title', '.template-search__search'],
    ['.blog-heading'],
    // Produktseite: Titelschrift + Zurueck-Knopf, NICHT die ganze Titelzeile. Die Zeile ist
    // genau eine Zelle hoch und laege mit ihrem Rechteck auf beiden Linien.
    ['.product__title-top h1', '.product-back'],
    ['.article-template__title'],
    // STILLGELEGT (25.09.2026) — die Rechtstexte binden jetzt die OBERKANTE ihres
    // Containers an die erste sichtbare Rasterlinie, nicht mehr die Mitte der Ueberschrift:
    //   ['.shopify-policy__title'],
    // Solange der Eintrag hier stand, setzte Regel 3 den Titel mittig ins Rasterfeld; der
    // Versatz landete als padding-top auf .shopify-policy__container (gemessen 92,2px).
    // Der neue Zweig steht weiter unten, Stichwort RECHTSTEXTE.
    // Beratungsseite: die UEBERSCHRIFT, wie auf jeder anderen Seite auch.
    //
    // Ohne Eintrag greift Regel 3 + 4 hier gar nicht — die Lage des Inhalts haengt dann an
    // der Kopfzeilenhoehe (variabel) und einem festen Sektionspolster (36px), beide kennen
    // das Raster nicht (gemessen 17.09.2026: bei 1264px 41,5px neben der Linie).
    //
    // Zwischenzeitlich stand hier die ganze PLATTE. Das legte die Linie zwar zuverlaessig
    // ueber sie, hatte aber einen sichtbaren Fehler: Regel 4 bindet die Rasterlage an die
    // MITTE des Blocks, und die Hoehe der Platte steht erst fest, wenn Schriften und
    // Formularfelder geladen sind. Beim Seitenaufbau sprang der Inhalt dadurch einmal hoch
    // und wieder zurueck (gemessen: Oberkante erst 330, dann 296).
    //
    // Mit der Ueberschrift als Block entfaellt das — sie ist hoehenstabil. Dass die Linie
    // dabei nicht mehr in die Platte faellt, liegt am kleineren Innenpolster: seit dem
    // 17.09.2026 sind es oben 1.5rem statt 3rem (sections/main-beratung.liquid), also 15px
    // mehr Luft zwischen Plattenkante und Schrift.
    ['.beratung-seite__titel'],
    ['.main-page-title'],
    ['.template-cart .title-wrapper-with-link'],
    ['.cart__warnings h1'],
    // STILLGELEGT (17.09.2026) - Regel 4 fuer die Fehlermeldung:
    //   ['.not-found-message h1']
    // Damit sass die Ueberschrift mittig im Rasterfeld, und weil der Vorspanntext darueber
    // steht, lag die Oberkante des Blocks frei zwischen zwei Linien (gemessen bei 1920:
    // Oberkante 322, Linien bei 285 und 375). Gewuenscht ist die Einrahmung oben; beides
    // zugleich geht nicht. Die Bindung steht jetzt in render() unter "FEHLERSEITE".
  ];
  // Folgeblock unter der Seitenueberschrift, der ebenfalls mittig ins Feld rastet:
  // Titel „Produkte" und Filterleiste der Suche.
  const FOLGE_ANKER = [
    // STILLGELEGT (25.09.2026) — mit dem Titel „Produkte":
    //   ['.search-layout > .collection-page-title', '.search-layout .facets-container'],
    // findeKopf() verlangt, dass das ERSTE Element einer Gruppe gefunden wird. Bliebe der
    // Eintrag stehen, wuerde die ganze Gruppe verworfen und die Filterleiste bekaeme gar
    // keine Rasterposition mehr. Sie ist jetzt selbst der Anker.
    ['.search-layout .facets-container'],
    // Shop: Filterleiste als eigener Block unter dem Titel (siehe KOPF_ANKER).
    ['.collection-with-sidebar__main .facets-container']
  ];

  // Vorhandenes Canvas entfernen (z.B. bei Hot-Reload im Editor)
  document.getElementById('grid-canvas')?.remove();

  /* === DAS CANVAS HAENGT AM DOKUMENT, NICHT AM FENSTER (23.09.2026) ==========
     VORHER: position: fixed, fenstergross, und bei jedem Scrollbild per JavaScript um
     "gezeichnetBei - scrollY" verschoben (Funktion ausgleichen()).

     WARUM DAS NICHT FUNKTIONIEREN KONNTE: Den Inhalt scrollt der Compositor - ein
     eigener Strang, der nie blockiert. Ein fest im Fenster liegendes Canvas bewegt sich
     dagegen NUR, wenn JavaScript auf dem Hauptstrang laeuft. Jede Millisekunde Arbeit
     dort ist damit unmittelbar sichtbarer Versatz.

     GEMESSEN im Grosshandels-Theme, Shopseite mit 200 Kacheln, 4,8 s Scrollen:

         Verschiebungen des Rasters :  36   (moeglich waeren 289, also 60 je Sekunde)
         mittlere Luecke            :  56,4 ms
         groesste Luecken           : 136, 108, 100, 95, 85 ms

     In jeder Luecke wandert der Inhalt weiter, waehrend das Raster steht. Ein Versuch,
     stattdessen die Zeichnung zu beschleunigen, drueckte die langen Aufgaben von 447 auf
     159 ms - am sichtbaren Bild aenderte das NICHTS. Die Ursache ist nicht die Dauer
     einer Zeichnung, sondern dass die LAGE ueberhaupt an JavaScript hing.

     JETZT steht das Canvas absolut in DOKUMENTKOORDINATEN und wird vom Browser zusammen
     mit dem Inhalt gescrollt - wie jedes andere Element. Es kann bauartbedingt nicht
     mehr nachlaufen, egal wie lange eine Zeichnung dauert und wie viele Kacheln geladen
     sind. Gezeichnet wird ein Band mit VORRAT Pixeln Reserve ueber und unter dem
     Fenster; neu gezeichnet erst, wenn das Fenster diesen Vorrat zu verlassen droht.

     DIESE AENDERUNG WURDE EINZELN EINGEBAUT, NICHT KOPIERT (CLAUDE.md: nie Dateien
     zwischen den Themes uebertragen). Im Grosshandels-Theme steht sie seit 23.09.2026
     live; die Datei dort ist an anderen Stellen abweichend. */
  const VORRAT = 900;   // Pixel Reserve ueber UND unter dem Fenster
  const NEU_AB = 650;   // ab so viel Abweichung vom Zeichenstand wird neu gezeichnet

  /* DIE HUELLE IST NOETIG, NICHT SCHMUECKENDES BEIWERK:
     Ein "fixed" Element steht ausserhalb des Seitenflusses und vergroessert die Seite
     nie. Ein "absolute" Element dagegen zaehlt zum scrollbaren Bereich. Ohne Huelle
     verlaengerte das Canvas - es ragt VORRAT Pixel unter das Fenster - die Seite um
     genau diesen Betrag. Man konnte weiterscrollen, das Canvas rueckte nach und
     verlaengerte erneut: eine Endlosschleife, an deren Ende nur noch Raster ohne Inhalt
     zu sehen war. Genau so ist es beim Umbau des anderen Themes passiert.

     IHRE HOEHE WIRD GEMESSEN, NICHT GEERBT: Zuerst stand dort inset: 0 in der Annahme,
     die Huelle spanne sich damit ueber das Dokument. Falsch - der body ist
     position: static, ein absolut gesetztes Element bezieht sich dann auf den
     Anfangs-Bezugsrahmen, und der hat FENSTERGROESSE. Die Huelle war dadurch 1080px
     hoch statt 3136 und schnitt das Raster fast vollstaendig weg. */
  document.getElementById('grid-huelle')?.remove();
  const huelle = document.createElement('div');
  huelle.id = 'grid-huelle';
  huelle.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: -1;
  `;

  const canvas = document.createElement('canvas');
  canvas.id = 'grid-canvas';
  canvas.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  `;
  huelle.appendChild(canvas);
  document.body.prepend(huelle);
  const ctx = canvas.getContext('2d');

  // Bezugspunkt fuer die Lage: Ein absolut gesetztes Element rechnet ab dem naechsten
  // positionierten Vorfahren, und ohne einen solchen ab dem Dokumentanfang. Welcher Fall
  // gilt, haengt davon ab, ob das Theme dem body eine Position gibt - deshalb gemessen
  // statt angenommen. Ohne diese Korrektur laege das ganze Raster um die Oberkante des
  // Vorfahren daneben.
  const bezugOben = () => {
    const p = canvas.offsetParent;
    if (!p) return 0;
    const s = getComputedStyle(p);
    return p.getBoundingClientRect().top + window.scrollY
      + (parseFloat(s.borderTopWidth) || 0);
  };

  // r.pad: positiv = Rechteck aufweiten (Standard), negativ = einziehen (kantentreu).
  const segOverlaps = (x1, y1, x2, y2, r) => {
    const p = r.pad;
    const left = r.left - p, right = r.right + p;
    const top = r.top - p, bottom = r.bottom + p;
    if (y1 === y2) {
      if (y1 < top || y1 > bottom) return false;
      return !(Math.max(x1, x2) < left || Math.min(x1, x2) > right);
    } else {
      if (x1 < left || x1 > right) return false;
      return !(Math.max(y1, y2) < top || Math.min(y1, y2) > bottom);
    }
  };

  const pointInRect = (x, y, r) => {
    const p = r.pad;
    return x >= r.left - p && x <= r.right + p &&
           y >= r.top - p && y <= r.bottom + p;
  };

  // Dokument-Y eines Elements über die offsetParent-Kette. Bewusst NICHT
  // getBoundingClientRect: die Empfehlungssektion trägt bei aktivierten Scroll-Animationen
  // ein transform (scroll-trigger/animate--slide-in), das die Rect-Messung während der
  // Einblendung um bis zu 2rem verfälschen würde. offsetTop ist eine reine Layout-Größe
  // und von transforms unberührt.
  const docTop = (el) => {
    let y = 0;
    for (let n = el; n; n = n.offsetParent) y += n.offsetTop;
    return y;
  };

  // === KACHELSEITEN (14.09.2026) ===
  // Das Kachelraster der Seite: Shop, Suchergebnisse, Neues, Rezepte. Bewusst NICHT die
  // Empfehlungen der Produktseite und nicht die "Verwendeten Produkte" eines Rezepts - die
  // haben ihr eigenes Mass.
  // STILLGELEGT (17.09.2026) - ohne die Favoritenseite:
  //   const SEITEN_KACHELRASTER = 'body.template-collection main .product-grid, body.template-search main .product-grid, main .blog-grid';
  // Die Favoritenseite ist eine Kachelseite wie Shop und Suche: drei Kacheln je Zeile,
  // jede ringsum von Rasterlinien eingerahmt. Sie traegt dafuer den Marker
  // .favoriten-raster (sections/favoriten.liquid).
  // NACHTRAG (24.09.2026): Die Suchseite war hier kurzzeitig herausgenommen, um ihr
  // padding-top loszuwerden. Das war falsch — ohne den Eintrag verliert die Suchseite die
  // Kachelausrichtung, und das Raster zwischen den Kacheln fehlt dann vollstaendig.
  // Der Eintrag bleibt also. Das Anliegen (nur EINE Linie zwischen Kopf und Filterleiste)
  // gehoert an eine andere Stelle, siehe FOLGE_ANKER.
  const SEITEN_KACHELRASTER = 'body.template-collection main .product-grid, body.template-search main .product-grid, main .favoriten-raster .product-grid, main .blog-grid';
  // elementeFinden statt document.querySelectorAll (23.09.2026): Diese Abfrage lief
  // VIERMAL je Zeichnung - seitenKachelRaster() und ersteSeitenKachel() rufen sie an
  // mehreren Stellen auf. Im anderen Theme gemessen: 24,8 ms auf 24 Aufrufe bei 200
  // Kacheln, damit der groesste Einzelposten nach dem Zerlegen der Sperrflaechen-Liste.
  // Der Selektor ist teuer, weil er ueber Nachfahren geht (body.template-… main
  // .product-grid) und der Browser dafuer keinen Schnellindex hat. Er laeuft jetzt je
  // Bild einmal; siehe "ELEMENTE SUCHEN" weiter unten. Aufgeteilt wird er NICHT - dafuer
  // hat er mit vier Teilen zu wenige, und einzeln waeren sie nicht billiger.
  const seitenKachelRaster = () =>
    elementeFinden(SEITEN_KACHELRASTER)
      .find((g) => g.offsetParent && !g.closest('.related-products, .article-template__linked-products'));
  // Das Element, das die Kachelbreite traegt (die Spalte): <li> im Shop, .blog-card im Blog.
  const ersteSeitenKachel = () => {
    const g = seitenKachelRaster();
    return g ? Array.from(g.children).find((k) => k.offsetParent && k.getBoundingClientRect().width > 0) : null;
  };
  // Die SICHTBARE Kachel (weicher Schnitt): im Shop die Box .product-card-wrapper (15 % groesser
  // als ihre Spalte), im Blog die Karte selbst.
  const sichtbareKachel = (k) => (k && (k.querySelector('.product-card-wrapper') || k)) || null;

  // === DR. HAUSCHKA: Rahmenbloecke (14.09.2026) ===
  // Die zuletzt eingepassten Bloecke der Markenseite. Jede Gruppe ist ein Rahmen: meist ein
  // Abschnitt, Credo + Drei-Spalten-Abschnitt gemeinsam. Beim Sammeln der Sperrflaechen wird
  // je Gruppe EIN Rechteck ueber alle ihre Abschnitte gelegt (weicher Schnitt).
  let drhGruppen = [];

  // === Empfehlungsblock auf das Raster einrasten ===
  // Der Tab-Block darüber ist je nach gewähltem Tab und je nach Produkt unterschiedlich hoch.
  // Weil die waagerechten Rasterlinien am DOKUMENT hängen (siehe offsetY in render), landete
  // "Das könnte Ihnen auch gefallen" damit bei jedem Produkt an einer anderen Stelle zwischen
  // den Linien — mal mittig (sah richtig aus), mal direkt auf einer Linie (wirkte versetzt und
  // wurde vom Raster durchzogen).
  // Deshalb wird die Sektion aktiv nach UNTEN bis zur passenden Rasterlage geschoben. Nach
  // unten, nie nach oben: ein negativer Versatz würde sie in den Tab-Block hineinziehen.
  // Der Zuschlag ist dadurch höchstens eine Zelle.
  //
  // REGLER --rel-snap-fraction am <body>: wo die MITTE der Überschrift im Rasterfeld sitzen
  // soll, in Zellen ab der Linie darüber. 0.5 = mittig zwischen zwei Linien (der Zustand, der
  // im Referenzbild richtig aussah), 0 = direkt auf der Linie.
  const snapRelatedProducts = (contentShift, shiftY) => {
    const rel = document.querySelector('.related-products');
    const heading = rel && rel.querySelector('.related-products__heading');
    // Die Überschrift entsteht erst, wenn product-recommendations.js den Abschnitt
    // nachgeladen hat. Vorher gibt es nichts auszurichten.
    if (!heading || !heading.offsetParent) {
      document.documentElement.style.removeProperty('--rel-snap');
      return;
    }
    // Ohne sichtbares Raster gibt es nichts, woran der Block einrasten koennte.
    // Auf dem Handy hat genau das gezittert: Der Block wurde Bild fuer Bild neu
    // ausgerichtet, an Linien, die dort gar nicht gezeichnet werden.
    if (!rasterSichtbar()) {
      document.documentElement.style.removeProperty('--rel-snap');
      return;
    }

    const rootStyle = document.documentElement.style;
    const bodyStyle = getComputedStyle(document.body);
    let fraction = parseFloat(bodyStyle.getPropertyValue('--rel-snap-fraction'));
    if (!Number.isFinite(fraction)) fraction = 0.5;

    // Waagerechte Linien liegen bei docY ≡ (contentShift + shiftY) mod SPACING — hergeleitet
    // aus offsetY in render(), das genau diese Phase gegen die Scrollposition rechnet.
    const phase = (((contentShift + shiftY) % SPACING) + SPACING) % SPACING;
    const target = phase + SPACING * fraction;

    const current = parseFloat(rootStyle.getPropertyValue('--rel-snap')) || 0;
    const center = docTop(heading) + heading.offsetHeight / 2;

    // ABSOLUT rechnen, nicht aufaddieren.
    //
    // Hier stand vorher:
    //     delta = (target - center) mod SPACING     // immer positiv
    //     next  = (current + delta) mod SPACING     // auf den alten Wert draufrechnen
    // Das setzt voraus, dass 'center' den bereits gesetzten Versatz exakt widerspiegelt.
    // Tut es das auch nur um einen Bruchteil nicht, ist delta nie null: Jedes Bild legt
    // erneut einen positiven Betrag drauf, der Block wandert um knapp eine Zelle pro
    // Bild nach unten und springt beim Ueberlauf zurueck. Gemessen auf dem Handy:
    // 40 verschiedene Werte in 40 Bildern, die Ueberschrift pendelte zwischen 383 und
    // 421px. Das war das Zittern.
    //
    // Jetzt wird die Lage OHNE den eigenen Versatz bestimmt und daraus der Zielwert
    // direkt berechnet. Das Ergebnis haengt nicht mehr vom vorherigen Wert ab, ist also
    // nach einem Bild stabil - egal wie ungenau zwischendurch gemessen wurde.
    const centerOhneVersatz = center - current;
    let next = (((target - centerOhneVersatz) % SPACING) + SPACING) % SPACING;
    // Produktseite nach Zeilenplan: Zwischen Reitern und Empfehlungen liegt immer mindestens
    // eine sichtbare waagerechte Linie. Die erste Linie unter den Reitern (samt weichem
    // Polster) muss oberhalb der Ueberschrift liegen, ebenfalls mit Polster. Reicht der
    // Versatz dafuer nicht, eine ganze Zelle mehr - die Mitte bleibt dabei im Feld.
    const tabs = document.querySelector('.product-tabs-section');
    if (tabs && tabs.offsetParent) {
      const tabsUnten = tabs.getBoundingClientRect().bottom + window.scrollY + PADDING;
      const linie = tabsUnten + (((phase - tabsUnten) % SPACING) + SPACING) % SPACING;
      const obenOhneVersatz = heading.getBoundingClientRect().top + window.scrollY - current;
      while (obenOhneVersatz + next < linie + PADDING + 1) next += SPACING;
    }

    // Nur schreiben, wenn sich wirklich etwas ändert. Sonst setzt jede Zeichnung eine neue
    // Style-Eigenschaft, und bei Subpixel-Rundung liefe das pro Frame hin und her.
    if (Math.abs(next - current) > 0.5) {
      rootStyle.setProperty('--rel-snap', next + 'px');
    }
  };

  // Ist das Raster ueberhaupt sichtbar? assets/mobile.css blendet die Zeichenflaeche
  // unter 750px und bei Tablets im Hochformat aus.
  // EINE Stelle fuer beide Verwendungen: die Zeichenbremse in render() und das Einrasten
  // des Empfehlungsblocks. Standen die Schwellen auseinander, richtete sich etwas an
  // einem Raster aus, das gar nicht zu sehen ist.
  const rasterSichtbar = () => {
    const w = window.innerWidth;
    const hochkantTablet = w < 1280 && window.matchMedia('(orientation: portrait)').matches;
    // HANDY QUER (14.09.2026): quer und hoechstens 500px hoch = kein Raster. Handys quer sind
    // 320-430px hoch, Tablets quer ab 744px. Gleiche Grenze wie in allen CSS-Dateien.
    const handyQuer = w < 1280 && window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches;
    // STILLGELEGT - vorher ohne Handy quer: return !(w < 750 || hochkantTablet);
    return !(w < 750 || hochkantTablet || handyQuer);
  };

  // === REGELN 1-4 (13.09.2026): Hilfen fuer Regel 3 + 4 ===
  // Erste Gruppe aus KOPF_ANKER/FOLGE_ANKER, deren erstes Element sichtbar ist.
  const findeKopf = (gruppen) => {
    for (const gruppe of gruppen) {
      const els = gruppe
        .map((sel) => Array.from(document.querySelectorAll(sel)).find((e) => {
          const b = e.getBoundingClientRect();
          return b.height > 0 && b.width > 0 &&
            (typeof e.checkVisibility !== 'function' || e.checkVisibility({ visibilityProperty: true })) &&
            !e.closest('.collection-categories');
        }))
        .filter(Boolean);
      if (els.length && els[0].matches(gruppe[0])) return { els };
    }
    return null;
  };
  // Umschliessendes Rechteck mehrerer Elemente in Dokumentkoordinaten.
  const vereinigung = (els) => {
    let top = Infinity, bottom = -Infinity;
    for (const e of els) {
      const b = e.getBoundingClientRect();
      top = Math.min(top, b.top + window.scrollY);
      bottom = Math.max(bottom, b.bottom + window.scrollY);
    }
    return { top, bottom };
  };
  // Das Element, das verschoben wird: vom Kopfblock aus nach oben bis zum groessten
  // Vorfahren, der weder einen harten Banner noch (beim Folgeblock) den Kopfblock enthaelt.
  const schiebeZiel = (el, mainEl, ausser) => {
    let z = el;
    while (z.parentElement && z.parentElement !== mainEl && z.parentElement !== document.body &&
           !z.parentElement.querySelector(HARTE_BANNER) &&
           !(ausser && z.parentElement.contains(ausser))) {
      z = z.parentElement;
    }
    return z;
  };
  // padding-top = eigenes Polster aus dem CSS + Versatz. Das Polster wird einmal ohne
  // Inline-Wert gelesen und gemerkt (bei Groessenaenderung neu, siehe resize).
  const versatzZiele = new Map();
  // Ziele, die im laufenden Bild benutzt wurden. Wechselt das Ziel (z.B. weil ein Banner
  // erst nach dem ersten Bild messbar ist), verliert das alte seinen Inline-Wert wieder -
  // sonst bliebe dort ein festgeschriebenes Polster stehen, das keiner mehr pflegt.
  let zieleImBild = new Set();
  // anker: die Elemente des Kopfblocks. Liegt eines davon absolut positioniert IN dem
  // verschobenen Element (dieses ist sein Bezugsrahmen), wandert es mit padding-top NICHT
  // mit - top misst ab der Innenkante einschliesslich Polster. So ist es ab 1280px beim
  // Titel „Produkte" der Suche: Die Filterleiste rutschte nach unten, der Titel blieb
  // stehen, der Block wurde hoeher, und die Rechnung kam nie zur Ruhe. Solche Teile
  // bekommen denselben Versatz ueber die CSS-Eigenschaft translate. Die ist vom transform
  // getrennt, mit dem der Titel waagerecht zentriert wird, und ueberschreibt ihn nicht.
  const setzeVersatz = (el, v, anker = []) => {
    zieleImBild.add(el);
    if (!versatzZiele.has(el)) {
      el.style.removeProperty('padding-top');
      versatzZiele.set(el, parseFloat(getComputedStyle(el).paddingTop) || 0);
      el.__kopfVersatz = undefined;
    }
    if (el.__kopfVersatz !== undefined && Math.abs(v - el.__kopfVersatz) <= 0.5) return;
    el.__kopfVersatz = v;
    el.style.setProperty('padding-top', (versatzZiele.get(el) + v) + 'px', 'important');
    const absolut = anker.filter((a) => a !== el && a.offsetParent === el &&
      getComputedStyle(a).position === 'absolute');
    (el.__kopfAbsolut || []).forEach((a) => { if (!absolut.includes(a)) a.style.removeProperty('translate'); });
    absolut.forEach((a) => a.style.setProperty('translate', '0 ' + v + 'px'));
    el.__kopfAbsolut = absolut;
  };
  const loeseAlleVersaetze = () => {
    if (!versatzZiele.size) return;
    versatzZiele.forEach((_, el) => {
      el.style.removeProperty('padding-top'); el.__kopfVersatz = undefined;
      (el.__kopfAbsolut || []).forEach((a) => a.style.removeProperty('translate'));
      el.__kopfAbsolut = undefined;
    });
    versatzZiele.clear();
  };

  // Oberkante des Inhalts beim ERSTEN Rendern (Dokumentkoordinaten). Referenz für den
  // Ausgleich weiter unten — siehe contentShift.
  let initialMainTop = null;

  // Zuletzt geschriebene Werte - siehe die Begruendung bei --cell in render().
  let lastCell = 0;
  let lastColumns = 0;
  let lastTbHoehe = 0;

  /* === ELEMENTE SUCHEN: ZERLEGT UND JE BILD NUR EINMAL (23.09.2026) =========
     GEMESSEN im Grosshandels-Theme bei 200 Kacheln und 12.787 Knoten, 4,3 s Scrollen,
     CPU-Profil ueber das DevTools-Protokoll:

         querySelectorAll        185 ms     <- fast die gesamte Rechenzeit
         getBoundingClientRect     5,6 ms
         closest                   2,5 ms
         checkVisibility           1,9 ms

     ZWEI URSACHEN, ZWEI MASSNAHMEN:

     1. DIESELBE ABFRAGE LIEF ZWEIMAL JE BILD. Die grosse Sperrflaechen-Liste (1220
        Zeichen, 63 Teile) wird an zwei Stellen gebraucht: in collectRects und unten in
        der Fusszeilen-Logik bei WEICH_ALLE. Die Fusszeile kann rects NICHT
        wiederverwenden, weil sie bewusst auch ausserhalb des Fensters misst - dieselbe
        ELEMENTLISTE aber schon. Der Speicher gilt nur fuer die laufende Zeichnung und
        wird an deren Anfang geleert; innerhalb einer Zeichnung laeuft alles synchron,
        das DOM kann sich also nicht aendern. Damit ist er bauartbedingt immer richtig.

        (Ein erster Anlauf speicherte ueber Bilder HINWEG und liess den MutationObserver
        verwerfen. Das brachte null: Beim Scrollen laufen 14 class-Aenderungen auf, der
        Speicher wurde also oefter verworfen als gelesen.)

     2. EINE SAMMELLISTE IST LANGSAMER ALS IHRE TEILE:

            die 63 Teile als EIN Ausdruck : 11,37 ms
            dieselben 63 Teile einzeln    :  4,78 ms
            teuerster Einzelteil          :  0,14 ms

        Kein Selektor ist fuer sich teuer. Bei einer langen Kommaliste kann der Browser
        seine Klassenindizes nicht nutzen und prueft breit durch.

     DIE REIHENFOLGE AENDERT SICH DABEI: Vereinigt wird ueber ein Set, die Liste steht
     danach nicht mehr in Dokumentlage. Das ist hier ohne Bedeutung - beide Verbraucher
     behandeln die Elemente als Flaechen. Wer das aendert, muss hier sortieren. */
  const AUFTEILEN_AB = 8;          // ab so vielen Kommateilen lohnt das Zerlegen
  const abfrageBild = new Map();   // gilt NUR fuer die laufende Zeichnung
  const elementeFinden = (selektor) => {
    const fertig = abfrageBild.get(selektor);
    if (fertig) return fertig;
    const teile = selektor.split(',');
    let liste;
    if (teile.length >= AUFTEILEN_AB) {
      const gesehen = new Set();
      for (let i = 0; i < teile.length; i++) {
        const s = teile[i].trim();
        if (!s) continue;
        const treffer = document.querySelectorAll(s);
        for (let j = 0; j < treffer.length; j++) gesehen.add(treffer[j]);
      }
      liste = Array.from(gesehen);
    } else {
      liste = Array.from(document.querySelectorAll(selektor));
    }
    abfrageBild.set(selektor, liste);
    return liste;
  };

  /* === WAS AM FENSTER KLEBT, SPERRT NICHT (23.09.2026) =====================
     Seit das Canvas am Dokument haengt, wird jede Aussparung an einer DOKUMENTSTELLE
     eingebrannt. Fuer Kacheln, Banner und die Fusszeile stimmt das - die stehen fest im
     Dokument und scrollen mit.

     Fuer position: sticky und position: fixed stimmt es NICHT. Die klebende Huelle der
     Kopfzeile (.section-header) sitzt beim Scrollen immer am oberen Fensterrand. Ihre
     Aussparung landet dadurch an der Dokumentstelle, an der der Fensterrand ZUM
     ZEITPUNKT DER ZEICHNUNG war - und wandert danach mit dem Canvas nach unten weg.
     Zwischen zwei Zeichnungen entsteht so ein rasterfreies Band, das ins Bild driftet.

     Im anderen Theme war genau das der letzte verbliebene Makel: Beim Runterscrollen
     wandert das Loch nach OBEN aus dem Bild und faellt nicht auf; beim Hochscrollen nach
     UNTEN hinein - erst am oberen Rand, nach dem Bremsen der Zeichnungen bis in die
     Bildmitte.

     Solche Elemente sperren deshalb gar nicht mehr. Sichtbar ist das nicht: Die
     Kopfzeile ist undurchsichtig und das Canvas liegt auf z-index -1 dahinter. Geprueft
     wird nicht nur das Element selbst, sondern auch seine Vorfahren - header.header-
     wrapper ist naemlich position: relative und klebt nur, WEIL .section-header darueber
     klebt. Die Antworten werden je Zeichnung gemerkt, damit getComputedStyle nicht fuer
     jeden Vorfahren erneut laufen muss. */
  const klebtSpeicher = new Map();
  const klebt = (el) => {
    if (!el || el === document.body || el === document.documentElement) return false;
    const gemerkt = klebtSpeicher.get(el);
    if (gemerkt !== undefined) return gemerkt;
    const p = getComputedStyle(el).position;
    const antwort = (p === 'fixed' || p === 'sticky') ? true : klebt(el.parentElement);
    klebtSpeicher.set(el, antwort);
    return antwort;
  };

  let scheduled = false;
  const render = () => {
    scheduled = false;
    // Zeitpunkt fuer die Bremse bei reinen Attributaenderungen (siehe scheduleGebremst).
    letzteZeichnung = performance.now();
    // Beide Speicher gelten nur fuer DIESE Zeichnung - siehe oben.
    abfrageBild.clear();
    klebtSpeicher.clear();
    // Scrollstand DIESER Zeichnung. Er legt fest, welchen Ausschnitt des Dokuments das
    // Band abdeckt - und damit auch, ab wann neu gezeichnet werden muss.
    gezeichnetBei = window.scrollY;
    const w = window.innerWidth, h = window.innerHeight;
    const dpr = window.devicePixelRatio || 1;
    // DAS BAND, in FENSTERKOORDINATEN gerechnet: oben negativ (also oberhalb des
    // Fensters), unten ueber die Fensterhoehe hinaus. Der gesamte Zeichencode weiter
    // unten rechnet unveraendert in Fensterkoordinaten - lediglich die Ausdehnung ist
    // groesser als frueher, wo sie genau 0 bis h war.
    const bandOben = -VORRAT;
    const bandUnten = h + VORRAT;
    const bandHoehe = bandUnten - bandOben;
    // NUR SETZEN, WENN SICH DIE MASSE WIRKLICH AENDERN: Eine Zuweisung an canvas.width
    // oder .height verwirft die gesamte Zeichenflaeche und legt sie neu an - auch bei
    // gleichem Wert. Bei 1920x2880 Punkten sind das rund 22 MB, die anschliessend neu
    // zur Grafikkarte muessen. Beim Scrollen aendert sich die Groesse aber gar nicht,
    // nur die Lage; es reicht, den Inhalt zu loeschen (clearRect weiter unten).
    const bBreite = Math.round(w * dpr);
    const bHoehe = Math.round(bandHoehe * dpr);
    if (canvas.width !== bBreite) canvas.width = bBreite;
    if (canvas.height !== bHoehe) canvas.height = bHoehe;
    if (canvas.style.width !== w + 'px') canvas.style.width = w + 'px';
    if (canvas.style.height !== bandHoehe + 'px') canvas.style.height = bandHoehe + 'px';
    // Die Huelle auf Dokumenthoehe bringen. Erst auf null, dann messen: So zaehlt sie
    // ihre eigene Hoehe nicht mit und die Seite waechst nicht Zeichnung um Zeichnung.
    huelle.style.height = '0px';
    huelle.style.height = document.documentElement.scrollHeight + 'px';
    // Die Lage im DOKUMENT. Ab hier scrollt der Browser das Canvas selbst mit dem
    // Inhalt mit - deshalb gibt es nichts mehr auszugleichen.
    canvas.style.top = (gezeichnetBei + bandOben - bezugOben()) + 'px';
    // Die Verschiebung bildet Fensterkoordinaten auf die Canvasflaeche ab:
    // Fenster-y = bandOben liegt auf Canvas-y = 0.
    ctx.setTransform(dpr, 0, 0, dpr, 0, -bandOben * dpr);
    ctx.clearRect(0, bandOben, w, bandHoehe);

    // Unsichtbare Elemente sind keine Sperrflaeche.
    //
    // Anlass ist die Kategorieauswahl (.collection-categories) im Tablet-Band und auf dem
    // Handy: ein Overlay mit position: fixed, geschlossen nur per visibility: hidden
    // ausgeblendet - getBoundingClientRect liefert trotzdem seine volle Groesse. Auf den
    // Blogseiten steckt darin die .blog-sidebar, und die steht in BLOCKING_SELECTORS:
    // Gemessen bei 1133x744 auf „Rezepte" eine Sperrflaeche vom Kopf bis zum Fensterrand,
    // vom Raster blieb nur die Spalte ganz rechts.
    //
    // STILLGELEGT - der erste Anlauf schloss alles INNERHALB von .collection-categories aus:
    //   .filter(el => !el.closest('.collection-categories'))
    // Das war zu grob. Am Desktop ist dieselbe Huelle display: contents und haelt das
    // sichtbare Seitenmenue neben den Kacheln - im Shop wie im Blog. Es sperrte dadurch
    // gar nicht mehr, die beige Platte lag hart auf den Linien statt sie am
    // naechstgelegenen Rasterpunkt enden zu lassen.
    //
    // Jetzt entscheidet die tatsaechliche Sichtbarkeit: visibility: hidden (vererbt vom
    // geschlossenen Overlay) faellt heraus, alles Sichtbare sperrt wie immer - egal, in
    // welcher Huelle es steckt. checkVisibility gibt es in allen aktuellen Browsern; wo
    // nicht, ersetzt der Blick auf die berechnete visibility dieselbe Pruefung.
    const sichtbar = (el) =>
      typeof el.checkVisibility === 'function'
        ? el.checkVisibility({ visibilityProperty: true })
        : getComputedStyle(el).visibility !== 'hidden';
    // REGELN 1-4 (13.09.2026): Was in einem hart schneidenden Element steckt (oder es
    // selbst ist), sperrt nicht zusaetzlich weich. Sonst naehme das Polster einer weichen
    // Sperrflaeche die Linien an der harten Kante mit weg - aus dem harten Schnitt wuerde
    // ein weicher. Die harten Flaechen selbst werden mit Polster 0 gesammelt.
    const collectRects = (selector, pad) =>
      // elementeFinden statt document.querySelectorAll: zerlegt abgefragt und je Bild
      // nur einmal - siehe "ELEMENTE SUCHEN" weiter oben. Gemessen wird darunter
      // unveraendert in JEDEM Bild; zwischengespeichert ist nur, WELCHE Elemente es
      // gibt, nie WO sie liegen.
      elementeFinden(selector)
        // klebt() zuerst: Was am Fenster klebt, darf in ein dokumentgebundenes Raster
        // keine Aussparung schneiden - siehe "WAS AM FENSTER KLEBT, SPERRT NICHT".
        .filter((el) => !klebt(el) && sichtbar(el)
          && (pad === 0 || !el.closest(HARD_CLIP_SELECTORS)))
        .map(el => {
          const r = el.getBoundingClientRect();
          if (pad >= 0) {
            return { left: r.left, right: r.right, top: r.top, bottom: r.bottom, pad };
          }
          // Kantentreue Flächen: die ungedrehte Box verwenden.
          // getBoundingClientRect liefert bei gedrehten Elementen (das Produktbild trägt eine
          // Neigung) die UMHÜLLENDE der Drehung — die ist größer als das Quadrat selbst und
          // ragt über die Rasterlinien hinaus, an denen die Kanten eigentlich liegen.
          // Da um den Mittelpunkt gedreht wird, ergibt Mitte ± halbe Layoutgröße die echte Box.
          const cx = (r.left + r.right) / 2;
          const cy = (r.top + r.bottom) / 2;
          const bw = el.offsetWidth || r.width;
          const bh = el.offsetHeight || r.height;
          return { left: cx - bw / 2, right: cx + bw / 2, top: cy - bh / 2, bottom: cy + bh / 2, pad };
        })
        // Auf das gezeichnete BAND begrenzen statt auf das Fenster: Das Canvas deckt
        // jetzt VORRAT Pixel ober- und unterhalb mit ab. Was dort liegt, muss mit
        // sperren - sonst fehlten die Aussparungen genau in dem Streifen, der beim
        // Scrollen als naechstes ins Bild kommt.
        .filter(r => r.right > r.left && r.bottom > r.top && r.bottom > bandOben && r.top < bandUnten);

    // Zusaetzliche Sperrflaeche NUR im Tablet-Querformat.
    //
    // Die rechte Spalte der Produktseite ist 4 Zellen breit, die Kaufbox darin 2,33.
    // In dem Streifen rechts neben der Kaufbox lief das Raster weiter und riss eine
    // Kerbe in die untere rechte Ecke der sonst geschlossenen Spalte. Am Schreibtisch
    // faellt das kaum auf, weil ringsherum viel freier Rand ist; im Querformat sitzt
    // der Inhalt dichter, und die Kerbe steht mitten im Blickfeld.
    //
    // .product__info-wrapper ist die Huelle ueber Infobox UND Kaufbox - genau das
    // Rechteck, das geschlossen sein soll. Die Infobox selbst sperrt bereits, aber
    // KANTENTREU (INSET_BLOCKING_SELECTORS): Ihre eigenen Kanten liegen auf Rasterlinien
    // und sollen sichtbar bleiben. Die Huelle daneben sperrt weich, das Raster endet
    // also am naechstgelegenen Rasterpunkt um sie herum.
    //
    // Bewusst nur in diesem Band und nicht generell: Am Schreibtisch veraendert es das
    // Bild der Referenzaufloesung, und danach war nicht gefragt.
    // Bis 1439.98px, nicht nur bis 1279.98px.
    //
    // Die Grenze bei 1280 stammt von der Kopfzeile und dem Seitenmenue - fuer die
    // Produktseite ist sie die falsche. Massgeblich ist hier, ob die Zelle kleiner ist
    // als das Designmass: Ab 1440px Fensterbreite greift min() auf --page-width, der
    // Container ist dann 1200px und die Zelle exakt 120px - also dieselbe Geometrie wie
    // bei 1920. Nachgemessen sind Titel (0,396 Zellen unter der Linie), Bild (0,177) und
    // rechte Spalte (0,946) bei 1440 und 1920 identisch. Dort gibt es nichts einzurasten.
    //
    // Unterhalb von 1440 schrumpft die Zelle, waehrend die Kopfzeile fast gleich hoch
    // bleibt - und genau daraus entsteht der Versatz. Bei 1280x800 sass der Titel
    // dadurch 0,695 Zellen unter der Linie statt der 0,255 bei 1210.
    //
    // Unter 1280 zusaetzlich Querformat verlangt: Hochkant gilt dort die Handy-Aufteilung
    // ohne Raster.
    const imQuerband =
      window.innerWidth >= 750 && window.innerWidth < 1440 &&
      // Handy quer (hoechstens 500px hoch) hat kein Raster, siehe rasterSichtbar.
      (window.innerWidth >= 1280 || window.matchMedia('(orientation: landscape) and (min-height: 500.02px)').matches);
    // KANTENTREU, nicht weich. Die Huelle rastet mit ihrer Oberkante genau auf eine
    // Rasterlinie ein (siehe --info-snap weiter unten). Beim weichen Schnitt legt sich
    // um jede Sperrflaeche noch ein Polster, und die Linie auf der Kante faellt damit
    // immer mit weg - die Huelle musste deshalb erst um Polster + 1px tiefer geschoben
    // werden, damit die Linie oberhalb frei blieb. Kantentreu entfaellt das: Entfernt
    // wird nur, was INNERHALB liegt, die Kantenlinie bleibt stehen.
    // Derselbe Weg wie bei .product__info-container und .product__media-item, deren
    // Kanten aus genau diesem Grund auf Rasterlinien liegen.
    // Diese Flaechen wechseln im Querband von WEICH auf KANTENTREU. Ihre Kanten liegen
    // dort auf Rasterlinien, und die sollen sichtbar bleiben - beim weichen Schnitt
    // nimmt das Polster sie mit.
    //   .product__info-wrapper  rechte Spalte der Produktseite
    //   .drh-credo/.drh-beratung  die beiden mittigen Bloecke der Dr.-Hauschka-Seite
    const IM_BAND_KANTENTREU = ['.product__info-wrapper', '.drh-credo', '.drh-beratung'];

    const kantentreueSperren = imQuerband
      ? INSET_BLOCKING_SELECTORS + ',' + IM_BAND_KANTENTREU.join(',')
      : INSET_BLOCKING_SELECTORS;
    // ... und muessen dann aus der weichen Liste heraus, sonst schneidet ihr Polster
    // weiterhin mit und die Kantenlinie faellt trotzdem weg.
    const weicheSperren = imQuerband
      ? BLOCKING_SELECTORS.split(',')
          .filter((sel) => IM_BAND_KANTENTREU.indexOf(sel.trim()) === -1)
          .join(',')
      : BLOCKING_SELECTORS;

    // STILLGELEGT - frueher drei Arten zu sperren:
    //   const rects = collectRects(weicheSperren, PADDING)
    //     .concat(collectRects(kantentreueSperren, -PADDING));
    //   const vRects = rects.concat(collectRects(V_BLOCKING_SELECTORS, -PADDING));
    // (kantentreu fuer Produktbild, Infobox und im Querband drei weitere Flaechen, nur
    // senkrecht fuer die Titelzone der Produktseite).
    //
    // REGELN 1-4 (13.09.2026), Regel 1: JEDES Element schneidet das Raster weich - das
    // Raster endet am naechstgelegenen Punkt rund um das Element. Harte Schnitte gibt es
    // nur noch an den fuenf Elementen in HARD_CLIP_SELECTORS. Die bisherigen Sonderlisten
    // gehen deshalb unveraendert in die weiche Liste ein; weicheSperren und
    // kantentreueSperren von oben bleiben stehen, werden aber nicht mehr gelesen.
    const rects = collectRects(
      // V_BLOCKING_SELECTORS (.product__title-top) STILLGELEGT: Die Titelzeile ist nach dem
      // Zeilenplan genau eine Zelle hoch, ihr Rechteck laege auf Linie 1 und 2 und loeschte
      // beide quer ueber die Seite. Weich schneiden stattdessen ihre sichtbaren Inhalte -
      // die Titelschrift (steht schon in BLOCKING_SELECTORS) und der Zurueck-Knopf.
      // Nachtrag 14.09.2026: die GANZE Titelzeile sperrt weich (vorher nur Titelschrift und
      // Knopf). Die Zeile ist dafuer ringsum um --pdp-einzug eingerueckt
      // (section-main-product.css, PRODUKTSEITE NACHTRAG) - Linie 1 und 2 bleiben stehen.
      // Vorher: [BLOCKING_SELECTORS, INSET_BLOCKING_SELECTORS, IM_BAND_KANTENTREU.join(','), '.product-back'].join(','),
      [BLOCKING_SELECTORS, INSET_BLOCKING_SELECTORS, IM_BAND_KANTENTREU.join(','), '.product-back', '.product__title-top'].join(','),
      PADDING
    );
    // Dr. Hauschka (14.09.2026): je Rahmengruppe ein gemeinsames weiches Rechteck. Bei Credo +
    // Spalten schliesst es die Luecke dazwischen ein - beide sind EIN Block im Raster.
    drhGruppen.forEach((g) => {
      const bs = g.filter((el) => el.isConnected).map((el) => el.getBoundingClientRect()).filter((b) => b.height > 0);
      if (!bs.length) return;
      rects.push({
        left: Math.min(...bs.map((b) => b.left)), right: Math.max(...bs.map((b) => b.right)),
        top: Math.min(...bs.map((b) => b.top)), bottom: Math.max(...bs.map((b) => b.bottom)), pad: PADDING
      });
    });
    const vRects = rects;
    // DIAGNOSE FUER PRUEFSKRIPTE (15.09.2026): Nur wenn ein Pruefskript window.__rasterDebug
    // VOR dem Laden setzt, werden die weichen Sperrflaechen dieses Bildes dort abgelegt. Im
    // Laden ist die Variable nie gesetzt - dann passiert hier nichts.
    if (window.__rasterDebug) {
      Object.assign(window.__rasterDebug, {
        weich: [BLOCKING_SELECTORS, INSET_BLOCKING_SELECTORS, IM_BAND_KANTENTREU.join(','), '.product-back', '.product__title-top'].join(','),
        rects: rects.map((r) => ({ left: r.left, right: r.right, top: r.top, bottom: r.bottom, pad: r.pad })),
        PADDING, SPACING, scrollY: window.scrollY
      });
    }
    const hardRects = collectRects(HARD_CLIP_SELECTORS, 0);

    // Senkrechte Linien an der linken Kante der Inhaltsspalte ausrichten
    // (statt am Viewport-Rand), damit Element-Kanten zuverlässig einrasten.
    let anchorX = 0;
    // Auf der Shop-Seite am Produkt-Container ankern (sonst passt das Raster nicht zu den Spalten).
    // Auf Shop- UND Blogseite am jeweiligen Sidebar-Container ankern (sonst passt das
    // Raster nicht zu den Spalten). Beim Blog ist das zwingend: Die erste .page-width im
    // <main> ist dort der Banner-Inhalt, der die normale Seitenbreite hat — das Raster
    // würde also nach dem Banner statt nach dem 14-Zellen-Layout berechnet.
    // Bewusst das erste SICHTBARE Element, nicht einfach das erste im DOM: Die Seite
    // einer leeren Kategorie (sections/main-404.liquid) haelt fuer jeden Blog eine
    // fertige .blog-layout bereit und blendet die passende erst per JS ein. Die
    // ausgeblendeten haben Breite 0 — als Anker gewaehlt, bliebe --cell ungesetzt und
    // das Raster verschwaende.
    // .search-layout ist das Gegenstueck auf der Suchergebnisseite: Die erste
    // .page-width im <main> ist dort das Suchfeld in normaler Seitenbreite, das
    // Raster wuerde also nach ihm statt nach dem 11-Zellen-Kachelblock berechnet.
    // EINE Suche über die ganze Kette statt einer ||-Verkettung. Der Unterschied ist
    // wesentlich: Bei || liefert schon der erste Ausdruck ein Element, sobald es EXISTIERT
    // — auch wenn es unsichtbar ist und Breite 0 hat. Genau das ist auf der Fehlerseite
    // passiert (sections/main-404.liquid hält eine ausgeblendete .blog-layout.page-width
    // bereit): Das Skript nahm sie als Bezugspunkt, konnte nichts messen und zeichnete
    // mit einem Notwert ins Leere. .find prüft dagegen JEDEN Kandidaten auf Sichtbarkeit
    // und nimmt den ersten brauchbaren.
    // Reihenfolge UND Sichtbarkeit. Beides ist nötig, und beides ging schon einmal schief:
    //  - Eine ||-Kette allein nimmt das erstbeste EXISTIERENDE Element, auch ein
    //    unsichtbares mit Breite 0 (passierte mit der ausgeblendeten Vorlage der 404-Seite).
    //  - Eine einzige querySelectorAll-Abfrage über alle Kandidaten liefert sie in
    //    DOKUMENT-Reihenfolge, nicht in Selektor-Reihenfolge. Der <header> trägt ebenfalls
    //    .page-width und steht ganz oben — er gewann dadurch gegen den Inhaltscontainer
    //    und machte die Zelle zu groß.
    // Deshalb: pro Stufe suchen, innerhalb der Stufe das erste SICHTBARE nehmen.
    const pickVisible = (selector) =>
      Array.from(document.querySelectorAll(selector)).find(
        (el) => el.getBoundingClientRect().width > 0
      );
    // .grid-anchor steht ganz vorn: ein leeres Element, das eine Seite ausdruecklich
    // als Bezugspunkt anbietet, wenn ihr eigener Inhaltscontainer dafuer nicht taugt
    // (Rechtstexte, Kontakt, Warenkorb — siehe layout/theme.liquid). Ist keines da,
    // aendert sich nichts an der bisherigen Reihenfolge.
    const ref =
      pickVisible('.grid-anchor') ||
      // Produktseite: der Produktcontainer selbst (Titelzeile + Bild/Info). Seine Kanten
      // liegen auf Rasterlinien, siehe GRID_SHIFT_X unten.
      pickVisible('.template-product main product-info > .page-width') ||
      pickVisible('.collection-with-sidebar, .blog-layout, .search-layout') ||
      pickVisible('main .page-width') ||
      pickVisible('.page-width');
    if (ref) {
      const rr = ref.getBoundingClientRect();
      const cs = getComputedStyle(ref);
      anchorX = rr.left + (parseFloat(cs.paddingLeft) || 0);

      // Rasterabstand an die Inhaltsbreite koppeln → skaliert 1:1 mit dem Inhalt
      // (beim Zoomen wird die Inhaltsspalte in CSS-Pixeln schmaler/breiter, das Raster
      // folgt proportional, sodass Boxkanten und Rasterlinien ausgerichtet bleiben).
      if (rr.width > 0) {
        // Spaltenzahl aus dem Platz ableiten (siehe resolveColumns weiter oben).
        // readColumns bleibt als Rueckfall, wenn kein Designmass deklariert ist.
        // STILLGELEGT, wo das Raster sichtbar ist - frueher immer:
        //   COLUMNS = resolveColumns(rr.width); SPACING = rr.width / COLUMNS;
        // Siehe globaleZelle: gleiche Zelle auf allen Seiten.
        if (rasterSichtbar()) {
          const g = globaleZelle();
          COLUMNS = g.spalten;
          SPACING = g.zelle;
        } else {
          COLUMNS = resolveColumns(rr.width);
          SPACING = rr.width / COLUMNS;
        }
        DOT_RADIUS = SPACING / 30; // Punktgröße proportional (= 4px bei 120px-Zelle)
        PADDING = SPACING / 15;    // Freiraum um Boxen proportional (= 8px bei 120px-Zelle)
        // Produktseite: Linien genau AUF den Kanten des Produktcontainers (V0 links, VR
        // rechts), nicht eine halbe Zelle versetzt - der Zeilenplan dort ist kantenbasiert.
        // STILLGELEGT - kurz vorher: Produktseite 0, sonst -SPACING / 2 (siehe SENKRECHTE
        // LINIEN AN DER FENSTERMITTE weiter unten, dort ist beides in einer Regel aufgegangen).
        GRID_SHIFT_X = -SPACING / 2;
        // Zellgröße als CSS-Variable veröffentlichen → Layout (Kacheln, Sidebar,
        // Lücken) rechnet in derselben Einheit wie das sichtbare Raster.
        // AUCH auf <body>, nicht nur auf <html>. Grund: body.template-collection und
        // die Geschwister (template-index, template-blog, ...) deklarieren --cell selbst
        // als Startwert (Ankerbreite / Spaltenzahl). Eine Deklaration am <body> schlaegt
        // die am <html> fuer ALLES darin — die gemessene Zelle kam also nie beim Layout
        // an, sondern nur beim gemalten Raster. Ergebnis: zwei verschiedene Zellgroessen.
        // Bei 1180px Fensterbreite rechnete der Hintergrund mit 83,2px, Sidebar und
        // Kacheln mit 90px; Inhalt und Raster liefen auseinander und rechts blieb ein
        // Streifen Raster ohne Inhalt.
        // Ein Inline-Style am body gewinnt gegen die CSS-Deklaration und macht die
        // gemessene Zelle zur EINEN Wahrheit. Bei der Referenzbreite 1920px sind beide
        // Werte ohnehin identisch (1260 / 14 = 90), dort aendert sich dadurch nichts.
        // NUR schreiben, wenn sich wirklich etwas geaendert hat.
        // Der MutationObserver am Ende dieser Datei lauscht auf attributes im gesamten
        // body-Teilbaum - also auch auf diesen Schreibvorgang. Wurde --cell bei jedem
        // Bild neu gesetzt, loeste jede Zeichnung die naechste aus: eine Dauerschleife
        // ueber requestAnimationFrame, die nie zur Ruhe kam und bei jedem Scrollbild
        // zusaetzlich zur eigentlichen Zeichnung lief. Genau das war das Ruckeln.
        // Die Schwelle von 0,01px ist Rundungsrauschen, keine echte Aenderung.
        if (Math.abs(SPACING - lastCell) > 0.01) {
          lastCell = SPACING;
          document.documentElement.style.setProperty('--cell', SPACING + 'px');
          if (document.body) document.body.style.setProperty('--cell', SPACING + 'px');
        }
        // Die tatsaechlich benutzte Spaltenzahl veroeffentlichen. BEWUSST unter einem
        // eigenen Namen und nicht als --grid-columns: Der deklarierte Wert ist die
        // Design-Vorgabe, aus der das Designmass berechnet wird. Ueberschriebe man ihn,
        // waere die Rechnung zirkulaer und die Spaltenzahl liefe von Bild zu Bild weg.
        if (COLUMNS !== lastColumns) {
          lastColumns = COLUMNS;
          document.documentElement.style.setProperty('--grid-columns-used', COLUMNS);
          if (document.body) document.body.style.setProperty('--grid-columns-used', COLUMNS);
        }
        // === Produktseite: Spaltenplan in ganzen Zellen ===
        // Breite T = hoechstens 11 Zellen, sonst so viele Spalten, wie die Zeile hat (bei
        // 750-891px quer sind es 7). Links 1 Zelle Einzug, dann Bild M, Luecke G, Info I:
        //   T = 11:  1 + 4 + 1 + 5      T = 7:  1 + 3 + 0 + 3
        // Die Werte gehen als CSS-Variablen an den <body> (section-main-product.css,
        // PRODUKTSEITE NACH ZEILENPLAN).
        if (document.body && document.body.classList.contains('template-product')) {
          const T = Math.min(11, COLUMNS);
          const M = Math.min(4, Math.floor((T - 1) / 2));
          const G = T >= 10 ? 1 : 0;
          const I = T - 1 - M - G;
          const plan = T + '/' + M + '/' + G + '/' + I;
          if (document.body.dataset.pdpPlan !== plan) {
            document.body.dataset.pdpPlan = plan;
            document.body.style.setProperty('--pdp-t', T);
            document.body.style.setProperty('--pdp-m', M);
            document.body.style.setProperty('--pdp-g', G);
            document.body.style.setProperty('--pdp-i', I);
          }
        }
      }
    }
    // Per-Seite-Versatz (optional) über CSS-Variablen am <body>:
    //   body.template-collection { --grid-shift-x: 40px; --grid-shift-y: -20px; }
    // x: + = nach rechts, - = nach links | y: + = nach unten, - = nach oben.
    // Fuer y gibt es zusaetzlich --grid-shift-y-cells (in Zellen statt px, siehe unten).
    // Leer/unbekannt = 0 → global unverändert.
    const bodyStyle = getComputedStyle(document.body);
    // Zusaetzlich --grid-shift-y-cells: derselbe Versatz, aber in RASTERZELLEN statt px.
    // Gebraucht, weil die Zelle an der Inhaltsbreite haengt (siehe SPACING oben): ein
    // px-Wert stimmt nur bei Design-Breite und wandert bei jeder anderen Fensterbreite
    // oder Zoomstufe aus der Rasterlage. In CSS laesst sich das nicht ausdruecken —
    // --grid-shift-y wird hier mit parseFloat als px gelesen, ein calc(var(--cell) * ...)
    // kaeme als NaN an. Beide Werte addieren sich; nicht gesetzt = 0 = unveraendert.
    // SPACING steht an dieser Stelle bereits auf dem gemessenen Wert.
    const shiftX = parseFloat(bodyStyle.getPropertyValue('--grid-shift-x')) || 0;
    // let statt const: Auf Seiten mit Kachelraster wird der Wert weiter unten aus der
    // Kachel-Oberkante berechnet, statt aus dem CSS uebernommen zu werden.
    let shiftY = (parseFloat(bodyStyle.getPropertyValue('--grid-shift-y')) || 0)
      + (parseFloat(bodyStyle.getPropertyValue('--grid-shift-y-cells')) || 0) * SPACING;

    // === SENKRECHTE LINIEN AN DER FENSTERMITTE (13.09.2026) ===
    // Wo das Raster sichtbar ist, liegen die senkrechten Linien auf JEDER Seite bei
    //     Fenstermitte + (k + 0,5) Zellen.
    // Warum: Seit alle Seiten dieselbe Zelle haben, passt der eigene Container vieler Seiten
    // nicht mehr in ganze Zellen (Dr. Hauschka 1118px bei 90px). Ihre Linienlage, bisher an
    // der Containerkante verankert und mit festen Versaetzen nachgezogen (--grid-shift-x:
    // -50px), stimmte dann nicht mehr - die Hero-Platte lag mit ihren Kanten mitten zwischen
    // zwei Linien.
    // Die Regel ergibt sich aus den Seiten, die schon rasterbuendig gebaut sind: Shop, Suche,
    // Blog und Produktseite haben ungerade Zellbreiten (7, 11) bzw. 14 mit halber Zelle Rand,
    // zentriert im Fenster - ihre Linien liegen genau dort. Dr. Hauschka (Platten 7/11/13
    // Zellen) liegt damit automatisch auf den Linien, und beim Wechsel zwischen den Seiten
    // bleibt das Raster stehen.
    // Gemessen an der Breite OHNE Scrollleiste, weil CSS die Container daran zentriert.
    // Der seitenweise Versatz --grid-shift-x entfaellt dabei; auf dem Handy (Raster
    // unsichtbar) bleibt alles wie bisher.
    // REGEL KACHELSEITEN 1 (14.09.2026): Jede Kachel ist links, rechts, oben und unten von einer
    // Rasterlinie eingerahmt. Kacheln stehen im Abstand von 4 Zellen und sind hoechstens 3,45
    // Zellen breit - ein Rahmen von 4 Zellen passt also genau, wenn eine Linie durch die
    // KACHELMITTE laeuft (Rahmen = Mitte +- 2 Zellen). Auf Kachelseiten (Shop, Suche, Neues,
    // Rezepte) werden die senkrechten Linien deshalb an der ersten Kachel ausgerichtet statt an
    // der Fenstermitte. Die Zelle bleibt dieselbe wie auf allen Seiten, nur die Lage folgt den
    // Kacheln. Ohne diese Bindung lag die Mitte bei 1440 eine Drittel-, bei 1180 und schmaler
    // eine halbe Zelle daneben - zwischen zwei Kacheln lief dann keine Linie.
    const kachelAnker = rasterSichtbar() ? ersteSeitenKachel() : null;
    if (kachelAnker) {
      const kb = kachelAnker.getBoundingClientRect();
      anchorX = (kb.left + kb.right) / 2;
    } else if (rasterSichtbar()) {
      anchorX = document.documentElement.clientWidth / 2 + GRID_SHIFT_X;
    } else {
      anchorX += GRID_SHIFT_X + shiftX;
    }
    const offsetX = (((anchorX % SPACING) + SPACING) % SPACING) - SPACING;

    // Waagerechte Linien: fix am Dokument verankert (NICHT an den Kacheln).
    // Dadurch bleibt das Hintergrundraster stehen, wenn du eine Box verschiebst;
    // nur die Rasterlücke unter der Box folgt (über die Blockliste), das ist gewollt.
    //
    // AUSGLEICH für Layout-Verschiebungen: Der Header wird beim Scrollen kompakter (der
    // Untertitel klappt zusammen, siehe base.css .header-compact). Dadurch verliert er Höhe
    // und der GESAMTE Inhalt darunter rutscht nach oben. Ein rein am Dokument verankertes
    // Raster bliebe dabei stehen — Inhalt und Linien liefen auseinander, waagerechte Linien
    // verschwänden hinter den Boxen.
    // Gemessen wird deshalb, wie weit sich die Inhalts-Oberkante gegenüber dem ersten Rendern
    // verschoben hat, und das Raster wandert um denselben Betrag mit.
    // Wichtig: Referenz ist der Startzustand, contentShift ist dort also 0 — die eingestellte
    // Rasterlage (--grid-shift-y) bleibt dadurch unverändert.
    const mainEl = document.querySelector('main');
    let contentShift = 0;
    if (mainEl) {
      const mainTopDoc = mainEl.getBoundingClientRect().top + window.scrollY;
      if (initialMainTop === null) initialMainTop = mainTopDoc;
      contentShift = mainTopDoc - initialMainTop;
    }
    // === Waagerechte Rasterlage an den INHALT binden statt in Pixeln einzustellen ===
    // --grid-shift-y ist ein fester Pixelwert (-60px im Shop). Er wurde einmal bei
    // Design-Breite so gewaehlt, dass eine Linie in der Luecke zwischen Filterleiste und
    // erster Kachelreihe sichtbar wird. Die Zelle ist aber nicht ueberall gleich gross,
    // und Kopfzeile und Banner sind ueberhaupt nicht in Zellen bemessen - ihre Hoehe
    // haengt an Schriftgroessen und Zeilenumbruechen. Bei jeder anderen Fensterbreite
    // landete die Linie deshalb woanders: mal mittig in der Luecke, mal direkt unter der
    // Leiste, mal quer durch die Kacheln. Genau deshalb musste bisher jede Aufloesung
    // einzeln nachjustiert werden.
    //
    // Statt einen Wert zu WAEHLEN wird er hier BERECHNET: Die Linie soll ein Viertel
    // einer Zelle ueber der Kachel-Oberkante liegen - das ist die Mitte der halben Zelle
    // Abstand, die .product-grid per margin-top zur Filterleiste haelt.
    //
    //   phase = (contentShift + shiftY) mod SPACING   (siehe offsetY direkt darunter)
    //   gewuenscht: phase = Kacheloberkante - 0,25 Zellen
    //   also:       shiftY = Kacheloberkante - 0,25 Zellen - contentShift
    //
    // Damit sitzt die Linie bei JEDER Fensterbreite an derselben Stelle relativ zum
    // Inhalt, ohne dass irgendwo eine Zahl gepflegt wird. Verschiebt man Titel oder
    // Filterleiste, wandert die Linie automatisch mit.
    //
    // REGLER --grid-snap-offset am <body>: wie weit ueber der Kachel-Oberkante die Linie
    // liegen soll, in Zellen. Nicht gesetzt = 0.25. Auf 0 gesetzt liegt sie genau auf der
    // Kachelkante.
    // Seiten ohne Kachelraster (Startseite, Beitraege, Rechtstexte) behalten den
    // eingestellten Pixelwert - dort gibt es keine Kachelkante, an die man binden koennte.
    // BEWUSST nicht einfach das erste .product-grid: Auf der Produktdetailseite ist das
    // einzige Kachelraster der Empfehlungsblock ("Das koennte Ihnen auch gefallen") - und
    // DER wird seinerseits per --rel-snap am Raster ausgerichtet (snapRelatedProducts).
    // Beides zusammen ist ein geschlossener Regelkreis: Die Rasterlage folgt dem Block,
    // der Block folgt der Rasterlage. Gemessen schrieb das Skript dadurch in jedem Bild
    // einen neuen Wert, die Ueberschrift wanderte ueber 17 verschiedene Positionen.
    // Gesucht ist das Kachelraster der SEITE (Shop, Suche), nicht das der Empfehlungen.
    // Auf der Produktseite bleibt es dadurch beim eingestellten --grid-shift-y, und das
    // Ausrichten des Empfehlungsblocks uebernimmt allein snapRelatedProducts.
    // Auf der PRODUKTSEITE gibt es kein Kachelraster, an das man binden koennte - dort
    // wird die Rasterlage an den TITEL gebunden. Das ist der Unterschied zum bisherigen
    // Weg, und er ist entscheidend:
    //
    // Vorher wurde der Titel verschoben, bis er ins Raster passte. Das ging im
    // Tablet-Band gut (wenige Pixel), scheiterte aber ab 1280px. Dort gilt die
    // Schreibtisch-Kopfzeile mit waagerechtem Menue, gemessen rund 65px hoeher als die
    // Tablet-Kopfzeile - der Titel startet also von ganz woanders, und der noetige
    // Versatz waere 47px nach oben gewesen: mitten unter die Kopfzeile. Nach unten
    // ausweichen ginge zwar, riss aber eine 95px hohe Luecke unter den Kopf.
    //
    // Jetzt bleibt der Inhalt stehen und das RASTER rueckt. Es verschiebt sich um
    // hoechstens eine Zelle, es kann mit nichts kollidieren, und oben entsteht keine
    // Luecke. Die Rechnung ist dieselbe wie beim Shop, nur andersherum aufgeloest:
    //     Linien liegen bei docY = phase (mod Zelle),  phase = contentShift + shiftY
    //     gewuenscht: Titeloberkante = phase + 0.25 Zellen
    //     also:       shiftY = (Titeloberkante - 0.25 Zellen) mod Zelle - contentShift
    //
    // ZIEL_IM_FELD ist die Lage IM RASTERFELD, in der die Titeloberkante sitzen soll -
    // gemessen von der Rasterlinie darueber, in Zellen. Groesser = mehr Luft zwischen
    // Linie und Titel, der Block sitzt also tiefer im Feld.
    //
    // Nicht zu verwechseln mit --pdp-kopfluft in section-main-product.css: Der Regler
    // schiebt den Block auf der SEITE nach unten - und weil das Raster hier an den Titel
    // gebunden ist, wandert es mit. Relativ zum Raster aendert sich dadurch nichts.
    // Wer den Block gegenueber den LINIEN verschieben will, aendert diesen Wert hier.
    // === Blogseiten: Ueberschrift unter dem Banner, Raster folgt ihr ===
    // Zwei Vorgaben, in dieser Reihenfolge:
    //   1. Die Ueberschrift beginnt BLOG_ABSTAND Zellen unter der Unterkante des Banners.
    //   2. Das Raster wird so gelegt, dass ihre Mitte genau zwischen zwei waagerechten
    //      Linien liegt.
    //
    // Frueher war es umgekehrt: Die Ueberschrift wurde verschoben, bis sie ins Raster
    // passte. Bei 1133px zog das sie 23px nach oben - so weit, dass sie einen Pixel UEBER
    // der Banner-Unterkante stand. Jetzt steht der Inhalt fest und das Raster rueckt; es
    // verschiebt sich dabei um hoechstens eine Zelle und kann mit nichts kollidieren.
    //
    // Der Versatz der Ueberschrift wird ABSOLUT berechnet (aus Banner-Unterkante und der
    // Lage der Ueberschrift ohne eigenen Versatz), nicht aufaddiert. Die Rasterlage haengt
    // nur von diesem Ergebnis ab und wirkt nicht auf das Layout zurueck - es gibt also
    // keine Schleife.
    //
    // Ohne Banner (manche Kategorieseiten) bleibt die Ueberschrift, wo der Fluss sie
    // hinsetzt; das Raster richtet sich trotzdem nach ihr.
    // ======================================================================
    // REGELN 1-4 (13.09.2026), Regel 3 + 4: Rasterlage an die SEITENUEBERSCHRIFT
    // ----------------------------------------------------------------------
    // Vorher war die Lage je Seitentyp anders geloest - im Shop an den Kacheln, im Blog
    // am Banner, auf der Produktseite an der Titeloberkante (0,33 im Feld), sonst ueber
    // feste Zellenwerte. Diese Wege stehen unten STILLGELEGT. Jetzt gilt eine Regel:
    //
    //   Regel 4  Die Mitte des Kopfblocks (Ueberschrift + Filter) liegt genau zwischen
    //            zwei waagerechten Linien. Zwischen harter Kante und Kopfblock liegt eine
    //            sichtbare Linie; der Block wird von nichts geschnitten.
    //   Regel 3  Diese Linie hat mindestens ABSTAND_RAND Zellen Abstand zur harten Kante
    //            (Kopfzeile oder Banner), an der das Raster beginnt.
    //
    // Mit T = Rasterbeginn, H = Hoehe des Blocks, c = seine Mitte, S = Zelle:
    //   Die Linie direkt ueber dem Block liegt bei c - (0,5 + k)*S, wobei k die kleinste
    //   Zahl ist, bei der der Block samt weichem Polster darunter Platz hat.
    //   Bedingung:  c - (0,5 + k)*S >= T + 0,4*S   ->   c >= T + (0,9 + k)*S
    // Liegt der Block hoeher, wird er um genau die fehlende Strecke nach unten gerueckt -
    // nie nach oben. Das Raster legt sich danach an seine Mitte.
    //
    // Gerueckt wird ueber padding-top am groessten umschliessenden Element, das noch
    // keinen harten Banner enthaelt: Alles darunter wandert mit, der Banner bleibt stehen.
    // Absolut gerechnet (eigener Versatz abgezogen), also ohne Rueckkopplung.
    const ABSTAND_RAND = 0.4;
    let kopfGebunden = false;
    {
      const alterBlog = document.documentElement.style.getPropertyValue('--blog-heading-snap');
      if (alterBlog) document.documentElement.style.removeProperty('--blog-heading-snap');
    }
    zieleImBild = new Set();
    const kopf = (rasterSichtbar() && mainEl) ? findeKopf(KOPF_ANKER) : null;
    // Rechtstexte werden nicht ueber den Titel gebunden, sondern ueber die Oberkante des
    // Containers — siehe den Zweig weiter unten.
    // Nur mit Ueberschrift darin: Sie ist der Anker, an dem gemessen wird.
    const policyContainer = (rasterSichtbar() && mainEl)
      ? Array.from(document.querySelectorAll('.shopify-policy__container'))
          .find((e) => e.offsetParent && e.querySelector('.shopify-policy__title'))
      : null;
    if (kopf) {
      const ziel = schiebeZiel(kopf.els[0], mainEl, null);
      const alt = ziel.__kopfVersatz || 0;
      const box = vereinigung(kopf.els);
      const obenNat = box.top - alt;
      const H = box.bottom - box.top;
      const mitteNat = obenNat + H / 2;
      let T = mainEl.getBoundingClientRect().top + window.scrollY;
      document.querySelectorAll(HARTE_BANNER).forEach((b) => {
        const r = b.getBoundingClientRect();
        if (r.height <= 0) return;
        const unten = r.bottom + window.scrollY;
        if (unten <= obenNat + 1) T = Math.max(T, unten);
      });
      const polster = PADDING + 1;
      const k = Math.max(0, Math.ceil((H / 2 + polster) / SPACING - 0.5 - 1e-6));
      const versatzBasis = Math.max(0, T + (ABSTAND_RAND + 0.5 + k) * SPACING - mitteNat);

      // FEINJUSTIERUNG JE SEITE (25.09.2026): --kopf-titel-y, in RASTERZELLEN.
      // Gelesen wird der Regler am ANKER selbst, nicht am body — so setzt ihn jede Seite in
      // ihrem eigenen Abschnitt, ohne Zuordnung ueber request.path. Ohne Eintrag: 0.
      //
      // ENTSCHEIDEND: Der Zuschlag geht NUR in die Lage des Blocks, NICHT in die Rasterlage.
      // Wuerde shiftY aus der verschobenen Mitte gerechnet, zoege das Raster mit und der
      // Abstand zur Linie bliebe derselbe — die Verschiebung waere unsichtbar. Deshalb
      // bindet die Rasterlage weiterhin an versatzBasis.
      const kopfY = parseFloat(getComputedStyle(kopf.els[0]).getPropertyValue('--kopf-titel-y')) || 0;
      const versatz = versatzBasis + SPACING * kopfY;

      setzeVersatz(ziel, versatz, kopf.els);
      const mitte = mitteNat + versatzBasis;
      shiftY = ((((mitte - SPACING * 0.5) % SPACING) + SPACING) % SPACING) - contentShift;
      kopfGebunden = true;

      // Folgeblock (Suche: „Produkte" + Filter) ebenfalls mittig ins Feld, nur nach unten.
      const folge = findeKopf(FOLGE_ANKER);
      if (folge) {
        const zielF = schiebeZiel(folge.els[0], mainEl, kopf.els[0]);
        if (zielF && zielF !== ziel && !zielF.contains(kopf.els[0])) {
          const altF = zielF.__kopfVersatz || 0;
          const bF = vereinigung(folge.els);
          // Lage ohne eigenen Versatz, dafuer mit dem NEUEN Versatz des Kopfblocks
          const mitteF = (bF.top + bF.bottom) / 2 - altF + (versatz - alt);
          const d = ((((mitte - mitteF) % SPACING) + SPACING) % SPACING);
          setzeVersatz(zielF, d > SPACING - 0.5 ? 0 : d, folge.els);
        }
      }
    } else if (policyContainer) {
      // === RECHTSTEXTE: OBERKANTE KNAPP UNTER DIE ERSTE LINIE (25.09.2026) ===
      // Der Container soll knapp unter der ersten SICHTBAREN waagerechten Rasterlinie
      // beginnen, aus der Zelle gerechnet statt als fester Pixelwert.
      //
      // ANKER UND ZIEL SIND VERSCHIEDEN: padding-top verschiebt die eigene Oberkante eines
      // Elements NICHT, nur seinen Inhalt. Gemessen wird deshalb die Ueberschrift,
      // gepolstert der Container darum — sonst schaukelt sich der Versatz auf (gemessen
      // 52.000px, die Seite war leer).
      //
      // DIE LINIE WIRD FESTGELEGT, NICHT GESUCHT: Ohne Kopfanker bindet niemand die
      // Rasterlage, shiftY bliebe 0 und die Phase waere zufaellig. Regel 3 sagt, wo die
      // erste sichtbare Linie fruehestens liegen darf (0,4 Zellen unter dem Rasterbeginn) —
      // genau dorthin wird sie gelegt und das Raster daran gebunden.
      const POLICY_LUFT = 0.05;
      const policyAnker = policyContainer.querySelector('.shopify-policy__title');
      const ziel = policyContainer;
      const alt = ziel.__kopfVersatz || 0;
      const obenNat = policyAnker.getBoundingClientRect().top + window.scrollY - alt;
      let T = mainEl.getBoundingClientRect().top + window.scrollY;
      document.querySelectorAll(HARTE_BANNER).forEach((b) => {
        const r = b.getBoundingClientRect();
        if (r.height <= 0) return;
        const unten = r.bottom + window.scrollY;
        if (unten <= obenNat + 1) T = Math.max(T, unten);
      });
      const LINIE_EPS = 0.002;   // Haarbreite unter die Bandkante, damit die Linie sicher gemalt wird
      const linie = T + SPACING * (ABSTAND_RAND + LINIE_EPS);
      shiftY = ((((linie - contentShift) % SPACING) + SPACING) % SPACING);

      // ABSTAND ZUR LINIE — nie kleiner als PADDING + 1. Der Container schneidet das Raster
      // WEICH, und um jede weiche Sperrflaeche legt sich ein Polster von PADDING. Eine
      // Linie, die naeher liegt, faellt mit weg. Denselben Hinweis gibt die Fehlerseite.
      // Dazu die Feinjustierung je Seite: --policy-titel-y, zugeordnet in layout/theme.liquid
      // ueber request.path (wie --page-bottom), Wert in base.css. Ohne Eintrag 0.
      const titelY = parseFloat(bodyStyle.getPropertyValue('--policy-titel-y')) || 0;
      const luftP = Math.max(SPACING * POLICY_LUFT, PADDING + 1) + SPACING * titelY;
      // Nach oben auf zwei Zellen gedeckelt: Notbremse gegen ein Aufschaukeln, nicht die Regel.
      const versatzP = Math.min(SPACING * 2, Math.max(0, linie + luftP - obenNat));
      setzeVersatz(ziel, versatzP, [policyAnker]);
      kopfGebunden = true;
    } else {
      loeseAlleVersaetze();
    }
    versatzZiele.forEach((_, el) => {
      if (zieleImBild.has(el)) return;
      el.style.removeProperty('padding-top');
      el.__kopfVersatz = undefined;
      (el.__kopfAbsolut || []).forEach((a) => a.style.removeProperty('translate'));
      el.__kopfAbsolut = undefined;
      versatzZiele.delete(el);
    });

    /* STILLGELEGT (13.09.2026) - ersetzt durch Regel 3 + 4 oben:
    const BLOG_ABSTAND = 0.2;
    const blogTitel = document.querySelector('.blog-heading');
    const blogBanner = document.querySelector('.blog-banner');
    let blogGebunden = false;
    {
      const rsB = document.documentElement.style;
      const altB = parseFloat(rsB.getPropertyValue('--blog-heading-snap')) || 0;
      if (rasterSichtbar() && blogTitel && blogTitel.offsetParent &&
          !document.querySelector('.product-grid:not(.related-products .product-grid)')) {
        const natuerlich = docTop(blogTitel) - altB;
        let versatzB = 0;
        if (blogBanner && blogBanner.offsetParent) {
          versatzB = docTop(blogBanner) + blogBanner.offsetHeight + SPACING * BLOG_ABSTAND - natuerlich;
        }
        if (Math.abs(versatzB - altB) > 0.5) rsB.setProperty('--blog-heading-snap', versatzB + 'px');
        const mitteB = natuerlich + versatzB + blogTitel.offsetHeight / 2;
        shiftY = ((((mitteB - SPACING * 0.5) % SPACING) + SPACING) % SPACING) - contentShift;
        blogGebunden = true;
      } else if (altB) {
        rsB.removeProperty('--blog-heading-snap');
      }
    }

    const ZIEL_IM_FELD = 0.33;
    const titelZone = document.querySelector('.product__title-top');
    const snapZiel = Array.from(document.querySelectorAll('.product-grid'))
      .find((g) => g.offsetParent && !g.closest('.related-products'));
    if (blogGebunden) {
      // Rasterlage steht bereits (Blogseite, siehe oben).
    } else if (!snapZiel && imQuerband && titelZone && titelZone.offsetParent) {
      const obenT = docTop(titelZone);
      shiftY = ((((obenT - SPACING * ZIEL_IM_FELD) % SPACING) + SPACING) % SPACING) - contentShift;
    } else if (snapZiel) {
      let versatz = parseFloat(bodyStyle.getPropertyValue('--grid-snap-offset'));
      if (!Number.isFinite(versatz)) versatz = 0.25;
      shiftY = docTop(snapZiel) - SPACING * versatz - contentShift;
    }
    Ende STILLGELEGT */

    const snapZiel = Array.from(document.querySelectorAll('.product-grid'))
      .find((g) => g.offsetParent && !g.closest('.related-products'));
    if (kopfGebunden) {
      // Rasterlage steht bereits (Regel 4, siehe oben).
    } else if (snapZiel) {
      let versatz = parseFloat(bodyStyle.getPropertyValue('--grid-snap-offset'));
      if (!Number.isFinite(versatz)) versatz = 0.25;
      shiftY = docTop(snapZiel) - SPACING * versatz - contentShift;
    }

    // === FEHLERSEITE: OBERKANTE DER MELDUNG AUF EINE RASTERLINIE (17.09.2026) ===
    // Wunsch des Users: Die Fehlermeldung soll oben von der ersten waagerechten Rasterlinie
    // eingerahmt werden. Gebunden wird deshalb die OBERKANTE des Blocks, nicht wie sonst die
    // Mitte der Ueberschrift (deren Eintrag in KOPF_ANKER ist dafuer stillgelegt).
    //
    // PADDING + 1 Abstand, weil .not-found-message das Raster weich schneidet: Um jede weiche
    // Sperrflaeche legt sich ein Polster, eine Linie genau auf der Kante faellt damit mit weg -
    // die Meldung stuende ohne die Linie da, die sie einrahmen soll.
    //
    // Der Block selbst wird NICHT verschoben. Ein erster Anlauf hat genau das getan und sich
    // damit selbst im Kreis gedreht: Jede Verschiebung bewegte den Anker, das Raster zog nach.
    // Wer die Meldung tiefer setzen will, dreht an --fehler-zeilen (base.css); das Raster
    // folgt ihr dann, die Einrahmung bleibt erhalten.
    const fehlerBlock = (!kopfGebunden && rasterSichtbar())
      ? Array.from(document.querySelectorAll('.not-found-message')).find((e) => e.offsetParent)
      : null;
    if (fehlerBlock) {
      shiftY = docTop(fehlerBlock) - PADDING - 1 - contentShift;
      kopfGebunden = true;
    }


    // === STARTSEITE: LINIE KNAPP UNTER DEN KATEGORIEKACHELN (14.09.2026) ===
    // Regel des Users: Wo das Raster sichtbar ist, liegt knapp unter den Kategoriekacheln eine
    // sichtbare waagerechte Linie - zwischen Kacheln und erster Zeile (Bild 1 + Text).
    // Die Rasterlage wird deshalb an die Unterkante des Kachelrasters gebunden:
    //   Linie = Unterkante + START_KACHEL_LUFT Zellen
    // Die Luft (0,15) ist groesser als der weiche Schnitt der Kachelflaeche (1/15), sonst
    // naehme deren Polster die Linie mit. Gemessen wird die LAYOUT-Unterkante (offsetTop/
    // offsetHeight), nicht das Rechteck mit Neigung - sonst liefe das Raster beim Anheben
    // einer Kachel (Hover) mit.
    // Die erste Zeile wird in der Startseiten-Einpassung weiter unten so gerahmt, dass sie
    // nie ueber diese Linie ragt. Die Linie ist dort ausserdem Pflichtlinie.
    const START_KACHEL_LUFT = 0.15;
    const startKachelRaster = (!kopfGebunden && document.body.classList.contains('template-index') && rasterSichtbar())
      ? Array.from(document.querySelectorAll('.category-tiles__grid')).find((g) => g.offsetParent)
      : null;
    if (startKachelRaster) {
      shiftY = docTop(startKachelRaster) + startKachelRaster.offsetHeight
        + SPACING * START_KACHEL_LUFT - contentShift;
    }

    const offsetY = -((((window.scrollY - contentShift - shiftY) % SPACING) + SPACING) % SPACING);

    // Lage der waagerechten Linien im DOKUMENT veroeffentlichen: docY ≡ phase (mod SPACING).
    // Hergeleitet aus offsetY eine Zeile darueber — dieselbe Rechnung, die auch
    // snapRelatedProducts benutzt. Andere Skripte koennen sich damit am Raster ausrichten,
    // ohne die Herleitung zu wiederholen; gebraucht wird sie derzeit von
    // assets/article-content-raster.js.
    document.documentElement.style.setProperty(
      '--grid-phase-y',
      ((((contentShift + shiftY) % SPACING) + SPACING) % SPACING) + 'px'
    );

    // === Hoehe von Titel + Filterleiste veroeffentlichen ===
    // Gebraucht von assets/component-filterbar-title.css, um das Paar mittig zwischen
    // zwei waagerechte Rasterlinien zu setzen. Warum das nicht in CSS allein geht:
    // Die Hoehe des Paares haengt an Schriftgroesse und Zeilenhoehe, ist also in Pixeln
    // praktisch konstant (gemessen 69,8px), waehrend die Zelle im Tablet-Band zwischen
    // 75 und 110px wandert. In Zellen ausgedrueckt ist das Paar mal 0,64 und mal 0,93
    // Zellen hoch - ein fester Zellenwert kann die Mitte deshalb nur bei genau einer
    // Fensterbreite treffen. Mit der gemessenen Hoehe wird daraus eine Rechnung, die
    // ueberall stimmt (Herleitung in component-filterbar-title.css).
    const tbTitel = document.querySelector('.collection-page-title');
    const tbLeiste = document.querySelector('.facets-container');
    if (tbTitel && tbLeiste && tbTitel.offsetParent && tbLeiste.offsetParent) {
      // Ohne den eigenen Folgeblock-Versatz der Leiste (Regel 4) gemessen: Die CSS-Formel in
      // component-filterbar-title.css setzt den Titel um die halbe Hoehe tiefer - zaehlte der
      // Versatz mit, schoebe er sich ueber diese Formel selbst weiter (Rueckkopplung).
      let leisteVersatz = 0;
      for (let n = tbLeiste; n && !n.contains(tbTitel); n = n.parentElement) leisteVersatz += n.__kopfVersatz || 0;
      // STILLGELEGT - vorher ohne Abzug:
      //   const hoehe = tbLeiste.getBoundingClientRect().bottom - tbTitel.getBoundingClientRect().top;
      const hoehe = tbLeiste.getBoundingClientRect().bottom
                  - tbTitel.getBoundingClientRect().top - leisteVersatz;
      if (hoehe > 0 && Math.abs(hoehe - lastTbHoehe) > 0.5) {
        lastTbHoehe = hoehe;
        document.documentElement.style.setProperty('--titelleiste-h', hoehe + 'px');
        document.body.style.setProperty('--titelleiste-h', hoehe + 'px');
      }
    }

    // === Rechte Spalte der Produktseite auf die Rasterlinie einrasten ===
    // Seit .product__info-wrapper im Querband eine weiche Sperrflaeche ist, verschwindet
    // die erste waagerechte Rasterlinie, die INNERHALB dieses Rechtecks liegt. Links
    // daneben bleibt sie stehen (das Produktbild sperrt kantentreu), die Linie bricht
    // also mitten auf der Seite ab.
    //
    // Ein fester Versatz loest das nicht. Der Abstand zwischen Wrapper-Oberkante und der
    // naechsten Linie haengt an der Rasterphase, und die liegt bei jeder Fensterbreite
    // anders: Bei 1133px lag die Linie 17px INNERHALB des Wrappers, bei 1210px genau auf
    // seiner Oberkante. Mit 0,25 Zellen sass es bei 1133 (mit 0,5px Luft), bei 1210 brach
    // die Linie weiterhin.
    //
    // Deshalb wird der Betrag berechnet: Gesucht ist die erste Linie ab der Oberkante,
    // und der Wrapper rueckt so weit nach unten, dass diese Linie samt Polster oberhalb
    // von ihm liegt. Der Versatz ist damit nie groesser als eine Zelle und meistens
    // deutlich kleiner.
    //
    // Gerechnet wird ABSOLUT, nicht aufaddiert: Der eigene Versatz wird von der gemessenen
    // Lage abgezogen, bevor die neue Lage bestimmt wird. Sonst schaukelt sich das auf -
    // derselbe Fehler, der den Empfehlungsblock zittern liess.
    const infoWrapper = document.querySelector('.product__info-wrapper');
    if (imQuerband && infoWrapper && infoWrapper.offsetParent) {
      const rootStyle2 = document.documentElement.style;
      const aktuell = parseFloat(rootStyle2.getPropertyValue('--info-snap')) || 0;
      const phaseDoc = (((contentShift + shiftY) % SPACING) + SPACING) % SPACING;
      const oben = docTop(infoWrapper) - aktuell;          // Lage ohne eigenen Versatz
      const ersteLinie = oben + (((phaseDoc - oben) % SPACING) + SPACING) % SPACING;
      // Die NAECHSTGELEGENE Linie, nicht die naechste nach unten.
      //
      // Genau auf die Linie (nicht darunter) ist richtig, seit die Huelle kantentreu
      // sperrt: Die Kantenlinie bleibt dann stehen. Nur nach unten zu runden war aber
      // zu grob - bei 1280px lag die naechste Linie 81px tiefer, und der Preisblock
      // sass dadurch weit unter der Bildoberkante. Nach oben waeren es 24px gewesen.
      // Nach beiden Seiten gerundet bleibt der Versatz unter einer halben Zelle.
      let versatzW = ersteLinie - oben;
      if (versatzW > SPACING / 2) versatzW -= SPACING;
      const naechster = versatzW;
      if (Math.abs(naechster - aktuell) > 0.5) {
        rootStyle2.setProperty('--info-snap', naechster + 'px');
      }
    } else if (document.documentElement.style.getPropertyValue('--info-snap')) {
      document.documentElement.style.removeProperty('--info-snap');
    }

    // === KACHELSEITEN: KACHELN UND "MEHR LADEN" IM RASTER (14.09.2026) ===
    // Regel 1 senkrecht: Jede Kachel liegt mittig in einem Rahmen aus ganzen Zellen (bei
    //   Box 3,45 bzw. Karte 3,55 Zellen und 4 Zellen Reihenabstand genau 4). Die Rasterlage
    //   selbst steht bereits (Regel 4: Seitenueberschrift + Filterleiste mittig im Feld); die
    //   KACHELN ruecken deshalb per padding-top am Kachelraster nach unten, bis die erste
    //   Kachel mittig im Feld liegt. Nur nach unten - nach oben liefe sie in die Filterleiste.
    // Regel 3: Der "Mehr laden"-Knopf liegt mittig zwischen zwei benachbarten Linien
    //   (Mitte = Linie + halbe Zelle). Verschoben wird er per translate um hoechstens eine
    //   halbe Zelle zur naechsten passenden Lage; das Band darunter bleibt stehen.
    // Beides ABSOLUT gerechnet (eigener Versatz vor dem Messen abgezogen).
    {
      const KACHEL_EINZUG = 0.15;
      const phaseK = (((contentShift + shiftY) % SPACING) + SPACING) % SPACING;
      const raster = rasterSichtbar() ? seitenKachelRaster() : null;
      const alleRaster = Array.from(document.querySelectorAll(SEITEN_KACHELRASTER));
      alleRaster.forEach((g) => {
        if (g !== raster && g.__kachelVersatz) {
          g.style.removeProperty('padding-top');
          g.__kachelVersatz = 0;
        }
      });
      if (raster) {
        const box = sichtbareKachel(ersteSeitenKachel());
        if (box) {
          const eigen = raster.__kachelVersatz || 0;
          const b = box.getBoundingClientRect();
          const hoehe = b.bottom - b.top;
          const zellen = Math.max(1, Math.ceil((hoehe + 2 * KACHEL_EINZUG * SPACING) / SPACING - 1e-6));
          const einzug = (zellen * SPACING - hoehe) / 2;
          const obenNat = b.top + window.scrollY - eigen;
          const versatz = ((((phaseK + einzug - obenNat) % SPACING) + SPACING) % SPACING);
          const v = versatz > SPACING - 0.5 ? 0 : versatz;
          if (Math.abs(v - eigen) > 0.5) {
            const basis = (parseFloat(getComputedStyle(raster).paddingTop) || 0) - eigen;
            raster.style.setProperty('padding-top', (basis + v).toFixed(2) + 'px', 'important');
            raster.__kachelVersatz = v;
          }
        }
      }
      document.querySelectorAll('.collection-load-more, .blog-load-more').forEach((knopf) => {
        const eigen = knopf.__knopfVersatz || 0;
        const sichtbarK = knopf.offsetParent && knopf.getBoundingClientRect().height > 0;
        if (!rasterSichtbar() || !sichtbarK) {
          if (eigen) { knopf.style.removeProperty('translate'); knopf.__knopfVersatz = 0; }
          return;
        }
        const b = knopf.getBoundingClientRect();
        const mitteNat = (b.top + b.bottom) / 2 + window.scrollY - eigen;
        // naechste Feldmitte (Linie + halbe Zelle)
        let d = ((((phaseK + SPACING / 2 - mitteNat) % SPACING) + SPACING) % SPACING);
        if (d > SPACING / 2) d -= SPACING;
        if (Math.abs(d - eigen) > 0.5) {
          knopf.style.translate = '0px ' + d.toFixed(2) + 'px';
          knopf.__knopfVersatz = d;
        }
      });
    }

    // === DR. HAUSCHKA: BLOECKE IM RASTERRAHMEN (14.09.2026) ===
    // Regeln des Users (alle Groessen mit Raster): Die Abschnitte der Markenseite schneiden
    // das Raster weich und sind an allen vier Seiten von einer sichtbaren Linie eingerahmt:
    //   Icons-Abschnitt | Credo + Drei-Spalten-Abschnitt GEMEINSAM | Kategorien | Features |
    //   Beratung.
    // WAAGERECHT kommt die Breite aus CSS (section-main-page.css, "BLOECKE IM RASTERRAHMEN"):
    //   hoechstens --rahmen-zellen - 0,3 Zellen. --rahmen-zellen wird hier veroeffentlicht -
    //   die groesste UNGERADE Zellenzahl, die ins Fenster passt. Ungerade, weil die Senkrechten
    //   symmetrisch zur Seitenmitte liegen (Mitte + (k+0,5) Zellen): Nur ein mittiger Rahmen
    //   ungerader Breite endet beidseitig auf einer Linie.
    // SENKRECHT werden die Gruppen hier der Reihe nach eingepasst: jede in die kleinste Zahl
    //   ganzer Zeilen mit mindestens 0,15 Zellen Abstand zu beiden Linien, mittig darin; der
    //   Rahmen beginnt an der ersten Linie, die mindestens den Grundabstand (3,5rem) zum
    //   vorigen Block laesst. Der erste Rahmen beginnt >= 0,4 Zellen unter der Hero-Flaeche
    //   (Regel 3), die letzte Rahmenlinie liegt eine halbe Zelle ueber der Fusszeile.
    //   Gesetzt wird margin-top am ersten Abschnitt jeder Gruppe (die Abschnitte haben im
    //   Raster margin-bottom 0, es gibt also nichts zu verschmelzen), bei der Beratung
    //   zusaetzlich margin-bottom. ABSOLUT gerechnet, jeweils aus der aktuellen Lage des
    //   vorigen Elements.
    {
      const seite = document.querySelector('.drh-page');
      const sektionen = seite ? Array.from(seite.children).filter((e) => e.matches('section.drh-section')) : [];
      if (!seite || !sektionen.length || !rasterSichtbar()) {
        sektionen.forEach((s) => {
          if (s.__drhMt !== undefined) { s.style.removeProperty('margin-top'); s.__drhMt = undefined; }
          if (s.__drhMb !== undefined) { s.style.removeProperty('margin-bottom'); s.__drhMb = undefined; }
        });
        if (document.body.style.getPropertyValue('--rahmen-zellen')) document.body.style.removeProperty('--rahmen-zellen');
        drhGruppen = [];
      } else {
        const remPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
        let rz = Math.floor((document.documentElement.clientWidth - remPx) / SPACING);
        if (rz % 2 === 0) rz -= 1;
        if (document.body.style.getPropertyValue('--rahmen-zellen') !== String(rz)) {
          document.body.style.setProperty('--rahmen-zellen', String(rz));
        }
        const EINZUG = SPACING * 0.15;
        const LUECKE = 3.5 * remPx;
        const phaseD = (((contentShift + shiftY) % SPACING) + SPACING) % SPACING;
        const linieAb = (y) => phaseD + Math.ceil((y - phaseD) / SPACING - 1e-6) * SPACING;
        const dok = (el) => { const b = el.getBoundingClientRect(); return { top: b.top + window.scrollY, bottom: b.bottom + window.scrollY }; };
        const gruppen = [];
        for (let i = 0; i < sektionen.length; i++) {
          const s = sektionen[i];
          if (s.classList.contains('drh-credo') && sektionen[i + 1] && s.nextElementSibling === sektionen[i + 1]) {
            gruppen.push([s, sektionen[i + 1]]);
            i++;
          } else {
            gruppen.push([s]);
          }
        }
        const hero = seite.querySelector(':scope > .drh-hero');
        let vorher = hero;
        let blockUnten = hero ? dok(hero).bottom : dok(seite).top;
        let linie = linieAb(blockUnten + SPACING * ABSTAND_RAND - 1);
        for (const g of gruppen) {
          const rs = g.map(dok);
          const oben = Math.min(...rs.map((r) => r.top));
          const h = Math.max(...rs.map((r) => r.bottom)) - oben;
          const versatzErster = oben - rs[0].top;
          const zeilen = Math.max(1, Math.ceil((h + 2 * EINZUG) / SPACING - 1e-6));
          const einzug = (zeilen * SPACING - h) / 2;
          let L = linie;
          while (L + einzug - blockUnten < LUECKE - 0.5) L += SPACING;
          const zielOben = L + einzug;
          const vorherUnten = vorher ? dok(vorher).bottom : dok(seite).top;
          const mt = zielOben + versatzErster - vorherUnten;
          if (g[0].__drhMt === undefined || Math.abs(g[0].__drhMt - mt) > 0.5) {
            g[0].style.setProperty('margin-top', mt.toFixed(2) + 'px', 'important');
            g[0].__drhMt = mt;
          }
          blockUnten = zielOben + h;
          vorher = g[g.length - 1];
          linie = L + zeilen * SPACING;
        }
        drhGruppen = gruppen;
        const letzte = vorher;
        const fuss = document.querySelector('footer.footer');
        if (letzte && letzte !== hero && fuss) {
          const aktuellMb = parseFloat(getComputedStyle(letzte).marginBottom) || 0;
          const basis = dok(fuss).top - aktuellMb;
          let ziel = linie + SPACING * 0.5;
          while (ziel < basis) ziel += SPACING;
          const mb = ziel - basis;
          if (letzte.__drhMb === undefined || Math.abs(letzte.__drhMb - mb) > 0.5) {
            letzte.style.setProperty('margin-bottom', mb.toFixed(2) + 'px', 'important');
            letzte.__drhMb = mb;
          }
        }
      }
    }

    snapRelatedProducts(contentShift, shiftY);

    // === STARTSEITE: ERSTES BILD AN DIE RASTERLINIEN (14.09.2026) ===
    // Wo das Raster sichtbar ist, rahmen zwei Linien das erste Bild der Startseite:
    //   links  dieselbe senkrechte Linie, die die Kategoriekacheln links einrahmt - die
    //          letzte Linie links der Kacheln, die ihr weicher Schnitt stehen laesst
    //   unten  die waagerechte MITTELLINIE - die Linie, die zugleich das zweite Bild oben
    //          einrahmt, also die letzte Linie ueber ihm
    // Zu beiden Linien haelt das Bild START_EINZUG Zellen Abstand (wie Bild und Infospalte
    // der Produktseite): groesser als der weiche Schnitt (1/15), sonst loeschte das Polster
    // die Rahmenlinie mit.
    // Liegt ueber dem zweiten Bild eine Linie NAEHER als dieser Einzug, rueckt das zweite
    // Bild um den fehlenden Rest nach unten (hoechstens einen Einzug). Sonst waere die Linie
    // direkt an seiner Kante verschluckt und die Mittellinie laege eine ganze Zelle hoeher -
    // das erste Bild muesste dann weit nach oben (852x393: 0,8 Zellen).
    // Verschoben wird ueber die CSS-Eigenschaft translate. Sie wirkt zusaetzlich zu Neigung und
    // Zellenversatz aus base.css (transform), ohne diese anzufassen, und aendert das Layout
    // nicht - also auch nicht die Rasterlage. Gerechnet wird ABSOLUT: der eigene Versatz wird
    // vor dem Messen abgezogen, sonst schaukelt es sich auf.
    const START_EINZUG = 0.15;
    // Rahmen fuer die Pflichtlinien beim Zeichnen (siehe MITTELLINIEN ALS PFLICHTLINIEN):
    // Ohne diese Bindung frass die Aufraeumregel die Mittellinie von rechts auf, sobald ihr
    // letzter Punkt am Textblock nur noch einen Strich hatte (1133, 1024: Linie fehlte ganz).
    let startRahmen = null;
    const medienStart = document.body.classList.contains('template-index')
      ? Array.from(document.querySelectorAll('main .image-with-text__media')).filter((m) => m.offsetParent)
      : [];
    const eigenerVersatz = (el) => {
      const t = (el.style.translate || '').split(' ').map(parseFloat);
      return [t[0] || 0, t[1] || 0];
    };
    const setzeVersatzBild = (el, dx, dy) => {
      const [ax, ay] = eigenerVersatz(el);
      if (Math.abs(ax - dx) < 0.5 && Math.abs(ay - dy) < 0.5) return;
      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) el.style.removeProperty('translate');
      else el.style.translate = dx.toFixed(2) + 'px ' + dy.toFixed(2) + 'px';
    };
    const kachelRaster = document.querySelector('.category-tiles__grid');
    if (medienStart.length >= 2 && kachelRaster && kachelRaster.offsetParent && rasterSichtbar()) {
      const [bild1, bild2] = medienStart;
      const natur = (el) => {
        const b = el.getBoundingClientRect();
        const [ox, oy] = eigenerVersatz(el);
        return { left: b.left - ox, right: b.right - ox, top: b.top + window.scrollY - oy, bottom: b.bottom + window.scrollY - oy };
      };
      const E = SPACING * START_EINZUG;
      const phaseY = (((contentShift + shiftY) % SPACING) + SPACING) % SPACING;
      const linieBis = (y) => phaseY + Math.floor((y - phaseY) / SPACING) * SPACING;   // Dokument
      const spalteBis = (x) => offsetX + Math.floor((x - offsetX) / SPACING) * SPACING; // Fenster
      // STILLGELEGT (15.09.2026) - n1 wird nach dem Schmaelern von Bild 1 neu gemessen:
      //   const n1 = natur(bild1);
      let n1 = natur(bild1);
      const n2 = natur(bild2);
      let mitte = linieBis(n2.top - E);
      // STILLGELEGT (14.09.2026, Nachtrag 2) - Bild 2 rueckte nur um den fehlenden Einzug:
      //   let dy2 = 0;
      //   if (mitte + SPACING <= n2.top) { mitte += SPACING; dy2 = mitte + E - n2.top; }
      if (mitte + SPACING <= n2.top) mitte += SPACING;
      // STILLGELEGT - vorher ohne Fensterpruefung:
      //   const links = spalteBis(kachelRaster.getBoundingClientRect().left - PADDING);
      // Die Linie, die die Kacheln links einrahmt, kann ausserhalb des Fensters liegen: Bei
      // 1024px (Zelle 84,5) endeten die Kacheln 2,7px rechts einer Linie, der weiche Schnitt
      // nahm diese, und die naechste lag bei x = -37 - das erste Foto begann bei -25px und war
      // links angeschnitten. Liegt die Linie nicht im Fenster, gilt die naechste rechts davon.
      let links = spalteBis(kachelRaster.getBoundingClientRect().left - PADDING);
      if (links - DOT_RADIUS < 0) links += SPACING;

      // BILD 1 NICHT IN DIE TEXTSPALTE (15.09.2026): Rueckt Bild 1 auf die naechste Linie, weil
      // die Kachel-Linie ausserhalb des Fensters liegt, ragte es bei 1024px 20px in die
      // Textspalte daneben. Dann wird nur der Bildrahmen schmaler - das Foto beschneidet per
      // object-fit: cover, die Hoehe bleibt -, sodass rechts BILD1_TEXT_LUFT Zellen Luft bleiben.
      const BILD1_TEXT_LUFT = 0.4;
      const textNachbar = bild1.closest('.image-with-text') &&
        bild1.closest('.image-with-text').querySelector('.image-with-text__text-item');
      if (bild1.__bildSchmal) {
        bild1.style.removeProperty('width'); bild1.style.removeProperty('max-width');
        bild1.__bildSchmal = false; n1 = natur(bild1);
      }
      if (textNachbar) {
        const platz = textNachbar.getBoundingClientRect().left - BILD1_TEXT_LUFT * SPACING - (links + E);
        if (platz < n1.right - n1.left - 0.5 && platz > SPACING) {
          bild1.style.setProperty('width', platz.toFixed(2) + 'px', 'important');
          bild1.style.setProperty('max-width', 'none', 'important');
          bild1.__bildSchmal = true; n1 = natur(bild1);
        }
      }

      // === ZENTRIEREN IM RASTERRAHMEN (14.09.2026, Nachtrag 2) ===
      // Ein Rahmen ist die kleinste Zahl GANZER Zellen, in die ein Element mit mindestens
      // START_EINZUG Abstand zu beiden Linien passt; darin liegt das Element mittig.
      //   Erste Zeile (Bild 1 + Textspalte daneben): nur SENKRECHT, der Rahmen endet unten an
      //     der Mittellinie. Waagerecht bleibt Bild 1 an der Kachel-Linie (+ Einzug), die
      //     Textspalte behaelt Lage und Breite.
      //   Bild 2: SENKRECHT zwischen Mittellinie und der Linie, die es unten einrahmt.
      //     WAAGERECHT zusaetzlich nur dann, wenn zwischen dem Text daneben
      //     (.image-with-text__text.rte) und dem Bild eine senkrechte Linie liegt - dann ist das
      //     Bild rundum vom Raster eingerahmt und das einzige Element in dieser Luecke.
      //     (Gemessen: 1920, 1440, 1280 ja; 1180 und schmaler liegt der Text bis ueber die Linie.)
      // STILLGELEGT - vorher: Bild 1 unten mit Einzug an der Mittellinie (dy1 = mitte - E - unten),
      // Bild 2 oben mit Einzug unter ihr.
      const zellenFuer = (laenge) => Math.max(1, Math.ceil((laenge + 2 * E) / SPACING - 1e-6));
      const mittigIn = (anfang, zellen, laenge) => anfang + (zellen * SPACING - laenge) / 2;

      const h1 = n1.bottom - n1.top;
      const z1 = zellenFuer(h1);
      const textSpalte = bild1.closest('.image-with-text') &&
        bild1.closest('.image-with-text').querySelector('.image-with-text__text-item');
      const nt = textSpalte ? natur(textSpalte) : null;
      const zt = nt ? zellenFuer(nt.bottom - nt.top) : 0;

      // REGEL 1 (14.09.2026): Zwischen Kacheln und erster Zeile liegt eine Linie - die Linie
      // knapp unter den Kacheln (STARTSEITE: LINIE KNAPP UNTER DEN KATEGORIEKACHELN). Kein
      // Rahmen der ersten Zeile darf darueber hinausragen; reicht der Platz nicht, rueckt die
      // Mittellinie (und mit ihr die zweite Zeile) zellenweise nach unten.
      const kachelLinie = linieBis(docTop(kachelRaster) + kachelRaster.offsetHeight + E + 1);
      mitte = Math.max(mitte, kachelLinie + Math.max(z1, zt) * SPACING);

      const dx1 = links + E - n1.left;
      const dy1 = mittigIn(mitte - z1 * SPACING, z1, h1) - n1.top;
      setzeVersatzBild(bild1, dx1, dy1);
      if (textSpalte) {
        const ht = nt.bottom - nt.top;
        setzeVersatzBild(textSpalte, 0, mittigIn(mitte - zt * SPACING, zt, ht) - nt.top);
      }

      // REGEL 2 (14.09.2026): Die Textspalte der zweiten Zeile liegt zwischen denselben
      // waagerechten Linien wie Bild 2. Beide teilen EINEN Rahmen ab der Mittellinie - so
      // hoch, wie das hoehere von beiden braucht - und liegen darin mittig.
      // STILLGELEGT - vorher nur das Bild: const z2 = zellenFuer(h2);
      const h2 = n2.bottom - n2.top;
      const w2 = n2.right - n2.left;
      const textSpalte2 = bild2.closest('.image-with-text') &&
        bild2.closest('.image-with-text').querySelector('.image-with-text__text-item');
      const nt2 = textSpalte2 ? natur(textSpalte2) : null;
      const z2 = Math.max(zellenFuer(h2), nt2 ? zellenFuer(nt2.bottom - nt2.top) : 0);
      const dy2 = mittigIn(mitte, z2, h2) - n2.top;
      if (textSpalte2) {
        const ht2 = nt2.bottom - nt2.top;
        setzeVersatzBild(textSpalte2, 0, mittigIn(mitte, z2, ht2) - nt2.top);
      }
      let dx2 = 0;
      const text2 = bild2.closest('.image-with-text') &&
        bild2.closest('.image-with-text').querySelector('.image-with-text__text.rte');
      const linksRahmen2 = spalteBis(n2.left - PADDING);
      if (text2 && text2.getBoundingClientRect().width > 0 &&
          linksRahmen2 - PADDING > text2.getBoundingClientRect().right) {
        const zw = zellenFuer(w2);
        // Rahmen so waehlen, dass er am linken Rahmen beginnt; ragt er dann aus dem Fenster,
        // bleibt es beim senkrechten Zentrieren.
        if (linksRahmen2 + zw * SPACING <= document.documentElement.clientWidth) {
          dx2 = mittigIn(linksRahmen2, zw, w2) - n2.left;
        }
      }
      setzeVersatzBild(bild2, dx2, dy2);

      // === STARTSEITE: TEXT UND ADRESSE MITTIG IN IHRER RASTERLUECKE (14.09.2026) ===
      // Regel des Users: Der Text neben Bild 2 (.image-with-text__content mit
      // .image-with-text__text rte body) und der Adressblock (.rich-text__blocks) liegen
      // jeweils senkrecht mittig in der Rasterluecke, in der sie stehen - also in der kleinsten
      // Zahl ganzer Rasterzeilen, die sie mit mindestens START_EINZUG Abstand fasst, und zwar
      // in der Lage, die ihrer bisherigen am naechsten kommt.
      // Ueberlappen sich die beiden Luecken, wird zuerst die Adresse nach unten, dann der Text
      // nach oben in die Nachbarluecke gerueckt. Geht beides nicht (Text nie ueber der
      // Mittellinie, Adresse nie naeher als 0,4 Zellen an der Fusszeile), werden beide
      // ZUSAMMENGESCHOBEN: Adresse direkt unter dem Text, beide gemeinsam mittig in einer Luecke.
      // Verschoben wird per translate (Layout unveraendert), absolut gerechnet.
      {
        const inhalt2 = bild2.closest('.image-with-text') &&
          bild2.closest('.image-with-text').querySelector('.image-with-text__content');
        const adresse = document.querySelector('main .rich-text__blocks');
        const fussEl = document.querySelector('footer.footer');
        if (inhalt2 && adresse && inhalt2.offsetParent && adresse.offsetParent) {
          const nA = natur(inhalt2);
          const nB = natur(adresse);
          const hA = nA.bottom - nA.top;
          const hB = nB.bottom - nB.top;
          const zA = zellenFuer(hA);
          const zB = zellenFuer(hB);
          const naechsteLuecke = (mitteY, z) => phaseY + Math.round((mitteY - z * SPACING / 2 - phaseY) / SPACING) * SPACING;
          const obenGrenze = mitte;
          const untenLinie = fussEl
            ? linieBis(fussEl.getBoundingClientRect().top + window.scrollY - SPACING * ABSTAND_RAND)
            : Infinity;
          let fA = Math.max(obenGrenze, naechsteLuecke((nA.top + nA.bottom) / 2, zA));
          let fB = Math.min(naechsteLuecke((nB.top + nB.bottom) / 2, zB), untenLinie - zB * SPACING);
          let getrennt = true;
          if (fA + zA * SPACING > fB + 0.5) {
            if (fA + zA * SPACING <= untenLinie - zB * SPACING + 0.5) {
              fB = fA + zA * SPACING;
            } else if (fB - zA * SPACING >= obenGrenze - 0.5) {
              fA = fB - zA * SPACING;
            } else {
              getrennt = false;
            }
          }
          if (fA < obenGrenze - 0.5 || fB + zB * SPACING > untenLinie + 0.5) getrennt = false;
          let obenA, obenB;
          if (getrennt) {
            obenA = mittigIn(fA, zA, hA);
            obenB = mittigIn(fB, zB, hB);
          } else {
            const h = hA + hB;
            const z = zellenFuer(h);
            let f = naechsteLuecke((nA.top + nA.bottom + nB.top + nB.bottom) / 4 + (hA - hB) / 4, z);
            f = Math.min(f, untenLinie - z * SPACING);
            f = Math.max(f, obenGrenze);
            obenA = mittigIn(f, z, h);
            obenB = obenA + hA;
          }
          // GLEICHE SENKRECHTE (15.09.2026, Wunsch des Users): Der Adressblock beginnt dort,
          // wo der Text neben Bild 2 beginnt. Massgeblich ist der SICHTBARE Textbeginn (erste
          // Zeile/Ueberschrift), nicht die Box: Der Adressblock traegt ein Innenpolster, sein
          // Text stand dadurch rund 0,2 Zellen weiter rechts (unter 1200px) bzw. bei 1920 um
          // 15px weiter links. Der Text neben dem Bild bleibt, die Adresse rueckt waagerecht.
          // STILLGELEGT - vorher nur senkrecht: setzeVersatzBild(adresse, 0, obenB - nB.top);
          const textBeginn = (el, sel) => {
            const kinder = Array.from(el.querySelectorAll(sel))
              .map((k) => k.getBoundingClientRect()).filter((b) => b.width > 0 && b.height > 0);
            return kinder.length ? Math.min(...kinder.map((b) => b.left)) : el.getBoundingClientRect().left;
          };
          const linksText = textBeginn(inhalt2, '.image-with-text__text > *');
          const linksAdresse = textBeginn(adresse, '.rich-text__text > *') - eigenerVersatz(adresse)[0];
          setzeVersatzBild(inhalt2, 0, obenA - nA.top);
          setzeVersatzBild(adresse, linksText - linksAdresse, obenB - nB.top);
        }
      }

      // Rahmen in Fensterlage: senkrecht an der Kachel-Linie von der Rahmen-Oberkante von
      // Bild 1 bis zur Mittellinie; waagerecht die Mittellinie unter Bild 1 und ueber Bild 2 -
      // jeweils von der Linie links bis zur Linie rechts des Bildes. Die Strecke ZWISCHEN den
      // beiden Bildern bleibt den normalen Regeln ueberlassen (dort kann Text stehen).
      startRahmen = {
        x: links,
        kacheln: kachelLinie - window.scrollY,
        oben: mitte - z1 * SPACING - window.scrollY,
        mitte: mitte - window.scrollY,
        spannen: [
          [links, spalteBis(n1.right + dx1 + PADDING) + SPACING],
          [spalteBis(n2.left + dx2 - PADDING), spalteBis(n2.right + dx2 + PADDING) + SPACING]
        ]
      };
    } else {
      medienStart.forEach((el) => setzeVersatzBild(el, 0, 0));
      medienStart.forEach((el) => {
        if (!el.__bildSchmal) return;
        el.style.removeProperty('width'); el.style.removeProperty('max-width'); el.__bildSchmal = false;
      });
      if (document.body.classList.contains('template-index')) {
        // STILLGELEGT - vorher nur die Textspalten:
        //   document.querySelectorAll('main .image-with-text__text-item').forEach(...)
        document.querySelectorAll('main .image-with-text__text-item, main .image-with-text__content, main .rich-text__blocks')
          .forEach((el) => setzeVersatzBild(el, 0, 0));
      }
    }

    // === FUSSZEILE IM RASTER (15.09.2026) ===
    // Regel 3 unten: Kein sichtbarer Punkt naeher als ABSTAND_RAND Zellen an der Fusszeile.
    // Lag die Fusszeile zufaellig 0 bis 0,4 Zellen unter einer Rasterzeile, entfiel diese
    // Zeile (Band) - die Senkrechten liefen dann von der Zeile darueber 1,0 bis 1,4 Zellen
    // ohne Punkt bis an die Fusszeile. Wo eine weiche Sperre (Produktempfehlungen) genau auf
    // der entfallenen Zeile endete, blieb ein Stummel ohne Punkt stehen, der wie hart
    // abgeschnitten aussah (Tablet quer 1210x834: Produktseite, Rechtstexte, Kontakt,
    // Warenkorb; der Warenkorb auch bei 1920).
    // Deshalb bekommt <main> unten so viel Polster, dass die Fusszeile FUSS_LAGE Zellen unter
    // der letzten Rasterzeile beginnt - nur wenn sie naeher als ABSTAND_RAND darunter laege.
    // Die Rasterlage haengt oben an der Seite, das Polster verschiebt sie also nicht.
    // Absolut gerechnet: das eigene Polster wird vor dem Messen abgezogen. Die Dr.-Hauschka-
    // Seite setzt ihren Abstand selbst (margin-bottom der letzten Gruppe) und bleibt aussen vor.
    // FUSSZEILE IM RASTER, Nachtrag (15.09.2026): Das Polster an <main> wirkte nur auf
    // Seiten, die laenger als das Fenster sind. Auf kurzen Seiten (Neues 1366x1024) ist
    // <body> eine Flex-Spalte mit min-height 100vh und <main> waechst mit flex 1 0 auto in
    // die freie Hoehe - das Polster wurde davon verschluckt, die Fusszeile blieb am
    // Fensterrand kleben. Jetzt wird die Fusszeilen-Gruppe per translate verschoben: Das
    // aendert kein Layout (also auch keine Rueckkopplung) und verlaengert die Seite um
    // genau diesen Betrag, auf kurzen wie auf langen Seiten.
    // STILLGELEGT - vorher Polster an <main>:
    // {
    //   const FUSS_LAGE = 0.5;
    //   const fussEl = document.querySelector('footer.footer');
    //   const eigen = mainEl ? (mainEl.__fussPolster || 0) : 0;
    //   let polster = 0;
    //   if (mainEl && fussEl && fussEl.getBoundingClientRect().height > 0 && rasterSichtbar() && !drhGruppen.length) {
    //     const phaseF = (((contentShift + shiftY) % SPACING) + SPACING) % SPACING;
    //     const fussNatur = fussEl.getBoundingClientRect().top + window.scrollY - eigen;
    //     const d = (((fussNatur - phaseF) % SPACING) + SPACING) % SPACING;
    //     if (d < SPACING * ABSTAND_RAND + 1) polster = SPACING * FUSS_LAGE - d;
    //   }
    //   if (mainEl && Math.abs(polster - eigen) > 0.5) {
    //     if (polster > 0.5) {
    //       const basis = (parseFloat(getComputedStyle(mainEl).paddingBottom) || 0) - eigen;
    //       mainEl.style.setProperty('padding-bottom', (basis + polster).toFixed(2) + 'px', 'important');
    //       mainEl.__fussPolster = polster;
    //     } else {
    //       mainEl.style.removeProperty('padding-bottom');
    //       mainEl.__fussPolster = 0;
    //     }
    //   }
    // }
    {
      const FUSS_LAGE = 0.5;
      const fussEl = document.querySelector('footer.footer');
      const gruppe = fussEl && (fussEl.closest('.shopify-section') || fussEl);
      // Reste des alten Polsters entfernen (offene Seiten nach dem Neuladen des Skripts).
      if (mainEl && mainEl.__fussPolster) {
        mainEl.style.removeProperty('padding-bottom');
        mainEl.__fussPolster = 0;
      }
      if (gruppe) {
        const eigen = gruppe.__fussVersatz || 0;
        let versatz = 0;
        if (fussEl.getBoundingClientRect().height > 0 && rasterSichtbar() && !drhGruppen.length) {
          const phaseF = (((contentShift + shiftY) % SPACING) + SPACING) % SPACING;
          const fussNatur = fussEl.getBoundingClientRect().top + window.scrollY - eigen;
          const d = (((fussNatur - phaseF) % SPACING) + SPACING) % SPACING;
          // STILLGELEGT - vorher nur der Abstand der letzten Rasterzeile zur Fusszeile:
          //   if (d < SPACING * ABSTAND_RAND + 1) versatz = SPACING * FUSS_LAGE - d;
          // FUSSZEILE IM RASTER, Nachtrag 2 (15.09.2026): Unter dem LETZTEN INHALT liegt eine
          // sichtbare waagerechte Linie, und von ihr bis zur Fusszeile sind es mindestens
          // ABSTAND_RAND Zellen. Vorher fehlte sie, wenn die einzige Rasterzeile zwischen
          // Inhalt und Fusszeile im weichen Polster des Inhalts lag: unter den
          // Produktempfehlungen bei 1138x712 und 1133x744 (Kacheln genau 1,0 Zellen ueber der
          // Fusszeile) - und bei 1280 auf Ueber uns, Kontakt, Versand und der Startseite, wo
          // die Senkrechten dadurch ohne Punkt bis in die Fusszeile liefen (Stummel, 1,5 bis
          // 1,9 Zellen ohne Punkt).
          // Gemessen wird in DOKUMENTLAGE und unabhaengig vom Fenster: dieselben weich
          // sperrenden Elemente wie bei rects, aber auch ausserhalb des sichtbaren Bereichs -
          // sonst haengt die Lage der Fusszeile an der Scrollposition und die Seite springt.
          // Beruecksichtigt wird, was hoechstens drei Zellen ueber der Fusszeile endet.
          const WEICH_ALLE = [BLOCKING_SELECTORS, INSET_BLOCKING_SELECTORS, IM_BAND_KANTENTREU.join(','), '.product-back', '.product__title-top'].join(',');
          let inhaltUnten = -Infinity;
          // Dieselbe Liste hat collectRects oben schon geholt. elementeFinden gibt sie
          // aus dem Bildspeicher zurueck, statt das Dokument ein zweites Mal
          // durchzusuchen - das waren gemessen 12,88 ms je Aufruf. Die Auswertung
          // darunter bleibt unveraendert: Sie misst bewusst auch ausserhalb des
          // Fensters, deshalb kann sie rects nicht verwenden, wohl aber die Elemente.
          elementeFinden(WEICH_ALLE).forEach((el) => {
            if (el.closest(HARD_CLIP_SELECTORS)) return;
            const b = el.getBoundingClientRect();
            if (b.width <= 0 || b.height <= 0) return;
            const unten = b.bottom + window.scrollY;
            if (unten > fussNatur + 1 || unten < fussNatur - 3 * SPACING) return;
            // klebt() statt der frueheren Pruefung auf position: fixed - sie erfasst
            // zusaetzlich sticky und, was hier den Ausschlag gibt, auch Elemente, die
            // nur wegen eines klebenden VORFAHREN am Fenster haengen. Fuer die Lage der
            // Fusszeile zaehlt allein, was fest im Dokument steht.
            if (!sichtbar(el) || klebt(el)) return;
            inhaltUnten = Math.max(inhaltUnten, unten);
          });
          let ziel = fussNatur;
          if (inhaltUnten > -Infinity) {
            // erste Rasterzeile, die das weiche Polster des Inhalts nicht mehr beruehrt
            const rahmen = phaseF + Math.ceil((inhaltUnten + PADDING + 0.5 - phaseF) / SPACING) * SPACING;
            if (ziel < rahmen + SPACING * ABSTAND_RAND - 1) ziel = rahmen + SPACING * FUSS_LAGE;
          }
          const dZiel = (((ziel - phaseF) % SPACING) + SPACING) % SPACING;
          if (dZiel < SPACING * ABSTAND_RAND + 1) ziel += SPACING * FUSS_LAGE - dZiel;
          versatz = ziel - fussNatur;
        }
        if (Math.abs(versatz - eigen) > 0.5) {
          if (versatz > 0.5) gruppe.style.setProperty('translate', '0 ' + versatz.toFixed(2) + 'px');
          else gruppe.style.removeProperty('translate');
          gruppe.__fussVersatz = versatz > 0.5 ? versatz : 0;
        }
      }
    }

    // ── Auf kleinen Bildschirmen NICHT zeichnen ───────────────────────────────────
    // assets/mobile.css blendet die Zeichenflaeche unter 750px mit display:none aus.
    // Das versteckte nur das Ergebnis — gerechnet und gezeichnet wurde weiter: Bei jedem
    // Scroll-Bild liefen die drei Doppelschleifen unten durch und setzten mehrere hundert
    // einzelne Zeichenbefehle ab, deren Ausgabe anschliessend niemand sah. Auf einem
    // iPhone faellt das nicht auf, auf schwaecheren Android-Geraeten sehr wohl.
    //
    // Die Schwelle ist BEWUSST dieselbe wie im CSS (749px). Stehen sie auseinander, gibt
    // es einen Bereich, in dem das Raster sichtbar waere, aber nicht gezeichnet wird.
    //
    // Die Pruefung steht HIER und nicht am Anfang der Funktion: Alles darueber wird auch
    // auf dem Handy gebraucht — --cell und --grid-phase-y werden weiter veroeffentlicht,
    // und andere Stellen im Theme rechnen damit (Abstaende im Warenkorb, der
    // Rasteranschluss der Beitragstexte). Ein frueher Ausstieg haette die stillschweigend
    // auf ihre Ersatzwerte zurueckfallen lassen.
    //
    // Und sie steht IN der Zeichenfunktion, nicht einmalig beim Start: Dreht jemand das
    // Handy quer, faellt die Bedingung beim naechsten Bild von selbst weg und das Raster
    // ist sofort da — ohne Neuladen, genau wie es der Kommentar in mobile.css zusichert.
    // Seit dem Tablet-Zwischendesign gilt die Mobilfassung (und damit das ausgeblendete
    // Raster) auch fuer Tablets im HOCHFORMAT — siehe die erweiterte Medienabfrage in
    // mobile.css. Die Bedingung hier zieht mit, sonst wird hochkant weitergezeichnet.
    // Quer bleibt das Raster: Dreht jemand das Tablet, faellt die Bedingung beim
    // naechsten Bild weg, ohne Neuladen.
    // HANDY QUER (14.09.2026), Wunsch des Users: Wo kein Raster ist, wird es nicht nur
    // ausgeblendet, sondern ENTFERNT - die Zeichenflaeche verlaesst das Dokument und kommt
    // erst zurueck, wenn das Raster wieder sichtbar ist (Tablet gedreht, Fenster groesser).
    // STILLGELEGT - vorher nur: if (!rasterSichtbar()) return;
    if (!rasterSichtbar()) {
      if (canvas.isConnected) canvas.remove();
      // Die Huelle auf null zusammenziehen, solange kein Raster da ist: Sie soll in
      // dieser Zeit weder Platz belegen noch die Seite verlaengern.
      huelle.style.height = '0px';
      return;
    }
    // ZURUECK IN DIE HUELLE, nicht an den body (23.09.2026). Vorher stand hier
    //   if (!canvas.isConnected) document.body.prepend(canvas);
    // Das war richtig, solange das Canvas fest im Fenster lag. Jetzt haengt es am
    // Dokument, und ausserhalb der Huelle fehlte ihm die Begrenzung: Es wuerde die Seite
    // um seinen Vorrat verlaengern, man koennte weiterscrollen, es rueckte nach - genau
    // die Endlosschleife von oben. Das trifft jeden, der ein Handy quer dreht und wieder
    // zurueck.
    if (!huelle.isConnected) document.body.prepend(huelle);
    if (canvas.parentNode !== huelle) huelle.appendChild(canvas);

    // Harte Schnittkanten: Canvas so clippen, dass innerhalb dieser Rechtecke
    // nichts gezeichnet wird (evenodd = Außenrechteck minus Löcher).
    ctx.save();
    if (hardRects.length) {
      ctx.beginPath();
      // Ueber das ganze BAND, nicht nur ueber das Fenster - sonst schnitte das
      // anschliessende clip() den Vorrat ober- und unterhalb komplett weg.
      ctx.rect(0, bandOben, w, bandHoehe);
      for (const r of hardRects) {
        // FEHLER, der hier lange stand: ctx.rect(r.left, r.top, r.width, r.height).
        // collectRects liefert {left, right, top, bottom, pad} — ein width/height gibt es
        // in diesen Objekten gar nicht. Beide Werte waren also undefined und wurden zu NaN.
        // Ein Rechteck mit NaN macht den ganzen Pfad unbrauchbar; das anschliessende
        // clip() schnitt dann je nach Browser ALLES weg — der Canvas blieb leer, ohne
        // jede Fehlermeldung. Genau das war auf den 404-Seiten zu sehen.
        const rw = r.right - r.left;
        const rh = r.bottom - r.top;
        if (rw > 0 && rh > 0) ctx.rect(r.left, r.top, rw, rh);
      }
      ctx.clip('evenodd');
    }

    // ========================================================================
    // GRUNDREGEL: Kein Punkt haengt an genau einem Strich.
    // ------------------------------------------------------------------------
    // Ein Rasterpunkt, von dem ein einzelner Strich wegfuehrt, sieht aus wie ein
    // Fehler - ein Stummel, der ins Leere laeuft. Solche Stummel entstehen an den
    // Raendern der Sperrflaechen: Von den vier Strichen eines Punktes fallen drei
    // weg, weil sie eine Box beruehren, und der vierte bleibt stehen.
    //
    // Punkte GANZ OHNE Strich sind ausdruecklich erlaubt. Sie wirken als gesetzte
    // Markierung, nicht als abgerissene Linie - und mitten in einer Aussparung
    // stehen sie ohnehin nicht, weil die Sperrflaechen auch die Punkte entfernen.
    //
    // Umgesetzt wird die Regel NICHT beim Zeichnen, sondern davor: Erst wird fuer
    // jeden Strich entschieden, ob er ueberhaupt gezeichnet wird, dann wird das
    // Ergebnis aufgeraeumt, und erst danach wird gemalt. Anders geht es nicht -
    // beim Zeichnen des ersten Strichs weiss man noch nicht, was aus den anderen
    // drei am selben Punkt wird.
    //
    // Wiederholt wird das Aufraeumen, weil das Entfernen eines Stummels den Punkt am
    // ANDEREN Ende selbst auf einen Strich fallen lassen kann. Ohne Grenze koennte
    // sich das durch eine ganze Linie fressen; MAX_DURCHGAENGE deckelt es. In der
    // Praxis ist nach zwei bis drei Durchgaengen Ruhe - mehr Durchgaenge greifen nur,
    // wo wirklich eine Kette von Stummeln haengt, und genau die soll ja weg.
    //
    // Das Gitter wird eine Masche GROESSER aufgebaut, als sichtbar ist. Sonst haetten
    // die Punkte am Bildrand kuenstlich zu wenige Nachbarn, und die Regel raeumte
    // Striche weg, die in Wirklichkeit weiterlaufen.
    const MAX_DURCHGAENGE = 12;

    // WO DIE REGEL GILT - und wo ausdruecklich nicht.
    //
    // Sie gilt nur beim WEICHEN Schnitt, also dort, wo das Raster rund um eine
    // Sperrflaeche am naechstgelegenen Rasterpunkt endet. Genau dort entstehen die
    // Stummel: Von den vier Strichen eines Punktes fallen drei weg, weil sie eine Box
    // beruehren, und der vierte laeuft ins Leere.
    //
    // Beim HARTEN Schnitt ist das anders. Kopfzeile, Fusszeile und die Textbanner
    // schneiden das Raster an ihrer Kante ab - das ist gewollte Gestaltung, und eine
    // Linie, die bis an diese Kante laeuft und dort endet, ist genau richtig. Dasselbe
    // gilt am Bildrand. An solchen Punkten darf die Regel nicht greifen; sonst nimmt
    // sie Linien weg, die hinlaufen SOLLEN.
    //
    // Zwei Anlaeufe lagen hier daneben, beide in dieselbe Richtung:
    //   - zuerst galt jeder Strich, der eine harte Kante beruehrt, als nicht vorhanden;
    //   - danach wurde er zwar gezaehlt, aber der Punkt konnte trotzdem aufgeraeumt
    //     werden, wenn die uebrigen drei Striche fehlten.
    // Beide Male verschwanden Linien an Kopf- und Fusszeile, die stehen bleiben sollten.
    //
    // Jetzt ist es umgekehrt geloest: Die harten Kanten aendern an der Entscheidung,
    // ob ein Strich gezeichnet wird, GAR NICHTS mehr - sie schneiden, mehr nicht. Sie
    // nehmen nur den Punkt von der Aufraeumregel aus.
    const hartBeteiligt = (i, j) => {
      const x = xs[i], y = ys[j];
      // Bildrand: einer der vier Striche fuehrt aus der Zeichenflaeche hinaus.
      if (x - SPACING < 0 || x + SPACING > w || y - SPACING < 0 || y + SPACING > h) return true;
      // Harte Kante in Reichweite eines der vier Striche.
      return hardRects.some((r) =>
        segOverlaps(x - SPACING, y, x, y, r) ||
        segOverlaps(x, y, x + SPACING, y, r) ||
        segOverlaps(x, y - SPACING, x, y, r) ||
        segOverlaps(x, y, x, y + SPACING, r));
    };

    const xs = [];
    for (let x = offsetX - SPACING; x < w + SPACING * 2; x += SPACING) xs.push(x);
    const ys = [];
    // Bis in den Vorrat hinein statt nur ueber die Fensterhoehe. Die Rasterphase
    // (offsetY) bleibt dabei unangetastet - der Startwert wird nur um ganze Vielfache
    // von SPACING nach oben gerueckt, bis er oberhalb des Bandes liegt. Die Linien
    // sitzen damit weiterhin an genau denselben Stellen im Dokument wie vorher.
    const ersteZeile = offsetY - Math.ceil((offsetY - bandOben) / SPACING + 1) * SPACING;
    for (let y = ersteZeile; y < bandUnten + SPACING * 2; y += SPACING) ys.push(y);

    // hStrich[i][j] = Strich von xs[i] nach xs[i+1] auf Hoehe ys[j]
    // vStrich[i][j] = Strich von ys[j] nach ys[j+1] auf Spalte xs[i]
    const hStrich = [];
    for (let i = 0; i < xs.length - 1; i++) {
      hStrich[i] = [];
      for (let j = 0; j < ys.length; j++) {
        hStrich[i][j] = !rects.some((r) => segOverlaps(xs[i], ys[j], xs[i + 1], ys[j], r));
      }
    }
    const vStrich = [];
    for (let i = 0; i < xs.length; i++) {
      vStrich[i] = [];
      for (let j = 0; j < ys.length - 1; j++) {
        vStrich[i][j] = !vRects.some((r) => segOverlaps(xs[i], ys[j], xs[i], ys[j + 1], r));
      }
    }

    // === PRODUKTSEITE: MITTELLINIEN ALS PFLICHTLINIEN (14.09.2026) ===
    // Zwei Linien rahmen das Produktbild und sind immer sichtbar, egal was sie weich
    // schneiden wuerde:
    //   senkrecht  die Linie rechts am Bild (rechte Kante von .product__media-wrapper,
    //              = V1 + Bildspalte), von Linie 2 bis Linie 6 (Ober-/Unterkante .product.grid)
    //   waagerecht Linie 6 (Unterkante .product.grid), ueber die ganze Breite
    // Nur harte Kanten (Clip) und Regel 3 (Baender weiter unten) gehen vor. Die Aufraeumregel
    // gegen Stummel laesst diese Striche und ihre Punkte in Ruhe.
    // Gebunden an den Zeilenplan (data-pdp-plan): Nur dort liegen die Kanten auf Linien.
    // Toleranz 1/4 Zelle - liegt eine Kante weiter daneben, ist das Layout nicht der
    // Zeilenplan, und es wird nichts erzwungen.
    const pflicht = new Set();
    if (document.body.dataset.pdpPlan) {
      const bildSpalte = document.querySelector('.product__media-wrapper');
      const block = document.querySelector('.product.grid');
      if (bildSpalte && block && sichtbar(bildSpalte) && bildSpalte.offsetWidth > 0) {
        const naechste = (arr, v) => {
          let k = 0;
          for (let n = 1; n < arr.length; n++) if (Math.abs(arr[n] - v) < Math.abs(arr[k] - v)) k = n;
          return Math.abs(arr[k] - v) < SPACING / 4 ? k : -1;
        };
        const bs = bildSpalte.getBoundingClientRect();
        const bb = block.getBoundingClientRect();
        const iMitte = naechste(xs, bs.right);
        const jOben = naechste(ys, bb.top);
        const jUnten = naechste(ys, bb.bottom);
        if (iMitte >= 0 && jOben >= 0 && jUnten > jOben) {
          for (let j = jOben; j < jUnten; j++) {
            vStrich[iMitte][j] = true;
            pflicht.add('v' + iMitte + ',' + j);
          }
          for (let j = jOben; j <= jUnten; j++) pflicht.add('p' + iMitte + ',' + j);
        }
        if (jUnten >= 0) {
          for (let i = 0; i < xs.length - 1; i++) {
            hStrich[i][jUnten] = true;
            pflicht.add('h' + i + ',' + jUnten);
          }
          for (let i = 0; i < xs.length; i++) pflicht.add('p' + i + ',' + jUnten);
        }
      }
    }
    // Startseite: Rahmenlinien des ersten Bildes (STARTSEITE: ERSTES BILD AN DIE RASTERLINIEN).
    if (startRahmen) {
      const index = (arr, v) => {
        let k = 0;
        for (let n = 1; n < arr.length; n++) if (Math.abs(arr[n] - v) < Math.abs(arr[k] - v)) k = n;
        return Math.abs(arr[k] - v) < 2 ? k : -1;
      };
      const iV = index(xs, startRahmen.x);
      const jO = index(ys, startRahmen.oben);
      const jM = index(ys, startRahmen.mitte);
      if (iV >= 0 && jO >= 0 && jM > jO) {
        for (let j = jO; j < jM; j++) {
          vStrich[iV][j] = true;
          pflicht.add('v' + iV + ',' + j);
        }
        for (let j = jO; j <= jM; j++) pflicht.add('p' + iV + ',' + j);
      }
      if (jM >= 0) {
        for (const [von, bis] of startRahmen.spannen) {
          const a = index(xs, von), b = index(xs, bis);
          if (a < 0 || b <= a) continue;
          for (let i = a; i < b; i++) {
            hStrich[i][jM] = true;
            pflicht.add('h' + i + ',' + jM);
          }
          for (let i = a; i <= b; i++) pflicht.add('p' + i + ',' + jM);
        }
      }
      // Regel 1: die Linie knapp unter den Kacheln, ueber die ganze Breite.
      const jK = index(ys, startRahmen.kacheln);
      if (jK >= 0) {
        for (let i = 0; i < xs.length - 1; i++) {
          hStrich[i][jK] = true;
          pflicht.add('h' + i + ',' + jK);
        }
        for (let i = 0; i < xs.length; i++) pflicht.add('p' + i + ',' + jK);
      }
    }

    // REGELN 1-4 (13.09.2026), Regel 3: Kein sichtbarer Punkt naeher als ABSTAND_RAND
    // Zellen an der Kante, an der das Raster beginnt (Unterkante der Kopfzeile bzw. eines
    // Banners) oder an der die Fusszeile es abschneidet. In diesem Band entfallen Punkte
    // und waagerechte Striche; die Senkrechten laufen weiter bis an die harte Kante.
    // Bewusst in DOKUMENTLAGE (Oberkante von <main>) und nicht an der mitlaufenden
    // Kopfzeile: Beim Scrollen soll das Band nicht mitwandern und Punkte ein- und
    // ausblenden, dort schneidet die Kopfzeile nur hart.
    const baender = [];
    if (mainEl) {
      const mt = mainEl.getBoundingClientRect().top;
      // 1px Toleranz: Regel 4 legt die erste Linie auf GENAU 0,4 Zellen unter diese Kante.
      // Mit Bruchteil-Pixeln landete sie bei 0,399 und fiel ins Band - die Linie, die
      // Regel 4 absichtlich dort platziert, verschwand (Produktseite: Linie 1 nur zu 6 %).
      // Unten um einen Punktradius IN die Kante hinein: Ein Punkt, dessen Mitte knapp
      // hinter der harten Kante liegt, wird dort abgeschnitten - sein Rand blieb aber als
      // Splitter vor der Kante stehen (Impressum 1280: Mitte 1px in der Fusszeile).
      baender.push([mt - DOT_RADIUS - 1, mt + SPACING * ABSTAND_RAND - 1]);
    }
    document.querySelectorAll(HARTE_BANNER + ', footer.footer').forEach((el) => {
      const b = el.getBoundingClientRect();
      if (b.height <= 0) return;
      baender.push([b.top - SPACING * ABSTAND_RAND + 1, b.top + DOT_RADIUS + 1]);
      baender.push([b.bottom - DOT_RADIUS - 1, b.bottom + SPACING * ABSTAND_RAND - 1]);
    });
    const zeileAus = ys.map((y) => baender.some(([von, bis]) => y > von && y < bis));
    for (let j = 0; j < ys.length; j++) {
      if (!zeileAus[j]) continue;
      for (let i = 0; i < xs.length - 1; i++) hStrich[i][j] = false;
    }

    // Aufraeumen: Punkte mit genau einem Strich verlieren ihn.
    for (let durchgang = 0; durchgang < MAX_DURCHGAENGE; durchgang++) {
      let geaendert = false;
      for (let i = 0; i < xs.length; i++) {
        for (let j = 0; j < ys.length; j++) {
          // Die vier moeglichen Striche an diesem Punkt, als Paare (Feld, Index).
          const anschluesse = [];
          if (i > 0 && hStrich[i - 1][j]) anschluesse.push(['h', i - 1, j]);
          if (i < xs.length - 1 && hStrich[i][j]) anschluesse.push(['h', i, j]);
          if (j > 0 && vStrich[i][j - 1]) anschluesse.push(['v', i, j - 1]);
          if (j < ys.length - 1 && vStrich[i][j]) anschluesse.push(['v', i, j]);
          if (anschluesse.length === 1 && !hartBeteiligt(i, j) &&
              !pflicht.has(anschluesse[0][0] + anschluesse[0][1] + ',' + anschluesse[0][2])) {
            const [art, a, b] = anschluesse[0];
            if (art === 'h') hStrich[a][b] = false;
            else vStrich[a][b] = false;
            geaendert = true;
          }
        }
      }
      if (!geaendert) break;
    }

    // ALLE Striche in EINEM Pfad (18.09.2026). Vorher bekam jeder Strich seinen eigenen
    // Pfad mit eigenem stroke - gemessen 423 Zeichenaufrufe je Bild, bei 21ms je Bild ein
    // spuerbarer Anteil. Sie teilen sich Farbe und Strichstaerke, das Bild ist deshalb
    // exakt dasselbe.
    ctx.strokeStyle = LINE_COLOR;
    ctx.lineWidth = LINE_WIDTH;
    ctx.beginPath();
    for (let i = 0; i < xs.length - 1; i++) {
      for (let j = 0; j < ys.length; j++) {
        if (!hStrich[i][j]) continue;
        // ausserhalb der Zeichenflaeche - das ist jetzt das Band, nicht das Fenster
        if (ys[j] < bandOben - 1 || ys[j] > bandUnten + 1) continue;
        ctx.moveTo(xs[i], ys[j]);
        ctx.lineTo(xs[i + 1], ys[j]);
      }
    }
    for (let i = 0; i < xs.length; i++) {
      for (let j = 0; j < ys.length - 1; j++) {
        if (!vStrich[i][j]) continue;
        if (xs[i] < -1 || xs[i] > w + 1) continue;
        ctx.moveTo(xs[i], ys[j]);
        ctx.lineTo(xs[i], ys[j + 1]);
      }
    }
    ctx.stroke();

    // Ebenso die Punkte. Das moveTo vor jedem Kreis ist PFLICHT: Ohne es verbindet der
    // gemeinsame Pfad die Kreise mit Linien.
    ctx.fillStyle = DOT_COLOR;
    ctx.beginPath();
    for (let i = 0; i < xs.length; i++) {
      for (let j = 0; j < ys.length; j++) {
        const x = xs[i], y = ys[j];
        if (zeileAus[j]) continue;   // Regel 3, siehe baender
        // Senkrecht gegen das Band pruefen, waagerecht unveraendert gegen die Breite.
        if (x < -DOT_RADIUS || x > w + DOT_RADIUS
          || y < bandOben - DOT_RADIUS || y > bandUnten + DOT_RADIUS) continue;
        if (!pflicht.has('p' + i + ',' + j) && vRects.some((r) => pointInRect(x, y, r))) continue;
        ctx.moveTo(x + DOT_RADIUS, y);
        ctx.arc(x, y, DOT_RADIUS, 0, Math.PI * 2);
      }
    }
    ctx.fill();

    ctx.restore();
  };

  const schedule = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(render);
    }
  };

  /* === GEBREMSTE ZEICHNUNG FUER BLOSSE ATTRIBUTAENDERUNGEN (23.09.2026) =====
     Beim ZURUECKscrollen baute sich das Raster in dem Bereich, der oben neu ins Bild
     kam, sichtbar erst auf - beim Runterscrollen nicht. Im anderen Theme ueber 97 Bilder
     eines Hochscrollens nachgemessen:

         Neuzeichnungen        : 25   (also etwa alle 60 ms eine)
         Kosten je Zeichnung   : 50 bis 80 ms
         Rasterphase dabei     : konstant
         Hoehe der Kopfzeile   : konstant

     Der Hauptstrang war damit durchgehend belegt, und dass weder Phase noch Kopfhoehe
     sich aenderten, zeigt: Die allermeisten dieser Zeichnungen haben nichts bewirkt.

     AUSGELOEST wurden sie vom MutationObserver. Beim Hochscrollen faehrt die klebende
     Kopfzeile wieder aus und der "Nach oben"-Knopf blendet sich ein - beide schalten
     dabei laufend Klassen um. Beim Runterscrollen passiert das nicht, deshalb trat es
     nur in eine Richtung auf.

     WAS GEBREMST WIRD UND WAS NICHT: Nur reine ATTRIBUT-Aenderungen laufen hierueber.
     Alles, was Knoten hinzufuegt oder entfernt (childList - etwa "Mehr laden"), und der
     erschoepfte Vorrat beim Scrollen loesen weiterhin SOFORT eine Zeichnung aus. Eine um
     bis zu 200 ms spaetere Aussparung um ein Element, das lediglich seine Klasse
     gewechselt hat, faellt nicht auf; eine fehlende Aussparung um eine neue Kachel
     schon. */
  const ATTRIBUT_BREMSE = 200;
  let letzteZeichnung = 0;
  let bremsUhr = 0;
  const scheduleGebremst = () => {
    if (bremsUhr) return;                       // es ist schon eine unterwegs
    const seit = performance.now() - letzteZeichnung;
    if (seit >= ATTRIBUT_BREMSE) { schedule(); return; }
    bremsUhr = setTimeout(() => { bremsUhr = 0; schedule(); }, ATTRIBUT_BREMSE - seit);
  };

  /* === RASTER FOLGT DEM SCROLLEN (neu gefasst 23.09.2026) ===================
     STILLGELEGT - was hier vorher stand und WARUM es weg musste:

       let gezeichnetBei = 0;
       const ausgleichen = () => {
         const d = gezeichnetBei - window.scrollY;
         canvas.style.transform = d ? 'translate3d(0,' + d + 'px,0)' : '';
       };
       window.addEventListener('scroll', () => { ausgleichen(); schedule(); });

     Die Idee war richtig gedacht: Das fest im Fenster liegende Canvas wurde im
     Scroll-Ereignis um denselben Betrag verschoben, um den sich die Seite bewegt hatte.
     Der Haken ist die Voraussetzung - dafuer muss JavaScript in JEDEM Bild laufen.

     Den Inhalt scrollt aber der Compositor, ein eigener Strang, der nie blockiert. Jede
     Millisekunde Arbeit auf dem Hauptstrang wurde damit unmittelbar zu sichtbarem
     Versatz. Nachgemessen im Grosshandels-Theme, 4,8 Sekunden Scrollen mit 200 Kacheln:

         Verschiebungen des Rasters :  36   (moeglich waeren 289, also 60 je Sekunde)
         mittlere Luecke            :  56,4 ms
         groesste Luecken           : 136, 108, 100, 95, 85 ms

     JETZT haengt das Canvas am Dokument (position: absolute, Lage in Dokumentkoordinaten,
     siehe oben bei der Erzeugung). Der Browser scrollt es zusammen mit den Kacheln - wie
     jedes andere Element. Es kann bauartbedingt nicht mehr nachlaufen.

     Neu gezeichnet wird nur noch, wenn das Fenster den gezeichneten Vorrat zu verlassen
     droht: bei NEU_AB Pixeln Abweichung, waehrend das Band VORRAT Pixel weit reicht. Die
     Differenz ist die Reserve, in der die Zeichnung fertig werden darf. */
  let gezeichnetBei = 0;

  // Bei Groessenaenderung das gemerkte Designmass verwerfen: Es haengt an rem und an
  // den Anker-Variablen (--shop-width & Co.), die eine Media Query aendern kann.
  window.addEventListener('resize', () => {
    designCell = null;
    // Auch den Bezugspunkt fuer den Inhaltsversatz verwerfen.
    // contentShift misst, wie weit die Inhalts-Oberkante gegenueber dem ERSTEN Rendern
    // gewandert ist - gedacht ist das fuer die zusammenklappende Kopfzeile beim
    // Scrollen. Aendert sich die Fensterbreite, wandert die Oberkante aber aus einem
    // ganz anderen Grund: Der Kopfbereich wird schmaler und dadurch hoeher oder
    // niedriger. Behielte man den alten Bezugspunkt, waere contentShift dauerhaft
    // falsch, und das Raster laege nach einem Drehen des Tablets an einer anderen
    // Stelle als beim Neuladen derselben Breite. Gemessen: --grid-phase-y stand nach
    // einem Wechsel von 834 auf 1024 auf 57,9px, frisch geladen auf 0px.
    initialMainTop = null;
    // Regel 4: gemerkte Polster verwerfen - sie haengen an Media Queries.
    loeseAlleVersaetze();
    schedule();
  });
  window.addEventListener('scroll', () => {
    // Hier ist nichts mehr auszugleichen - der Browser scrollt das Canvas selbst mit.
    // Gezeichnet wird erst, wenn das Fenster den Vorrat zu verlassen droht. Das ist der
    // eigentliche Gewinn: Beim Scrollen laeuft in den allermeisten Bildern GAR KEIN
    // JavaScript mehr, und genau deshalb kann das Raster nicht mehr zurueckbleiben.
    if (Math.abs(window.scrollY - gezeichnetBei) > NEU_AB) schedule();
  }, { passive: true });

  // === KOPFZEILE KLAPPT EIN ODER AUS (18.09.2026) ===
  // Der Untertitel klappt als CSS-Uebergang zusammen (base.css, 0.12s). Dabei aendert sich
  // die Hoehe der Kopfzeile Bild fuer Bild und der ganze Inhalt darunter rueckt nach - aber
  // es gibt in dieser Zeit weder eine DOM-Aenderung noch ein Scroll-Ereignis, an dem eine
  // neue Zeichnung haengen koennte. Ohne Zutun zeichnet das Raster also einmal am Anfang
  // und einmal am Ende, waehrend der Inhalt dazwischen wandert.
  // Solange der Uebergang laeuft, wird deshalb in jedem Bild gezeichnet. Das Fenster ist
  // begrenzt, damit daraus keine Dauerlast wird.
  let kopfRahmen = 0;
  const kopfBewegtSich = () => {
    cancelAnimationFrame(kopfRahmen);
    const start = performance.now();
    const weiter = () => {
      schedule();
      // 400ms: Uebergang 120ms plus Reserve fuer langsame Geraete.
      if (performance.now() - start < 400) kopfRahmen = requestAnimationFrame(weiter);
    };
    kopfRahmen = requestAnimationFrame(weiter);
  };
  // In der Erfassungsphase (drittes Argument true): transitionrun steigt nicht auf, wenn
  // ein Zwischenelement es abfaengt.
  document.addEventListener('transitionrun', (ereignis) => {
    const ziel = ereignis.target;
    if (ziel && ziel.classList && ziel.classList.contains('header__subtitle')) kopfBewegtSich();
  }, true);

  // Aenderungen am Canvas SELBST loesen keine neue Zeichnung aus. Ohne diese Ausnahme
  // wuerde der Ausgleich oben - er setzt das transform des Canvas - bei jedem Scrollbild
  // eine weitere Zeichnung anstossen und sich selbst im Kreis drehen.
  const observer = new MutationObserver((eintraege) => {
    let nurAttribute = false;
    for (const eintrag of eintraege) {
      // Canvas UND Huelle ausnehmen. Die Huelle kam am 23.09.2026 dazu, und sie hier zu
      // vergessen war im anderen Theme teuer: render() setzt ihre Hoehe, der Beobachter
      // meldete das, und die naechste Zeichnung setzte sie erneut - jede Zeichnung loeste
      // die naechste aus. Gemessen 8657 ms Skript in 9,6 s Scrollen, 124 lange Aufgaben.
      // Wer hier ein weiteres eigenes Element einfuehrt, muss es mit aufnehmen.
      if (eintrag.type === 'attributes'
        && (eintrag.target === canvas || eintrag.target === huelle)) continue;
      // Struktur aendert sich (Knoten kommen oder gehen) -> sofort zeichnen.
      // Nur ein Attribut gewechselt -> ueber die Bremse, siehe scheduleGebremst.
      if (eintrag.type === 'childList') { schedule(); return; }
      nurAttribute = true;
    }
    if (nurAttribute) scheduleGebremst();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true });

  // Erste Zeichnung wenn DOM bereit
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // Noch einmal messen, wenn ALLES geladen ist.
  //
  // Das gemerkte Designmass wurde bisher nur bei einer Groessenaenderung verworfen. Das
  // genuegt nicht: Es stammt aus dem CSS (--shop-width / --grid-columns), und wenn ein
  // Stylesheet erst nach der ersten Zeichnung ankommt, ist die Messung falsch - und
  // bleibt es, weil nichts sie mehr anfasst. Sichtbar wird das als fehlende oder
  // verschobene Rasterlinien, die nach einem Neuladen der Seite verschwunden sind.
  //
  // Auftreten kann das im Entwicklungsserver (er tauscht CSS im laufenden Betrieb aus,
  // ohne dass sich die Fenstergroesse aendert) ebenso wie im Laden bei langsamer
  // Verbindung. load feuert erst, wenn Stylesheets, Schriften und Bilder da sind - was
  // dort gemessen wird, ist der endgueltige Zustand.
  window.addEventListener('load', () => { designCell = null; initialMainTop = null; schedule(); });
})();